import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import _ from 'lodash';

import { saveAs } from 'file-saver';

//utils
import queries from '../../utils/queries'

import HomeConf1 from './homeconf1';
import HomeConf2 from './homeconf2';

import ConfServ1 from './conf/confserv1';
import ConfServ2 from './conf/confserv2';
import AddServicio1 from './conf/addservicio1';
import AddServicio2 from './conf/addservicio2';
import VerSer1 from './conf/verser1';
import VerSer2 from './conf/verser2';

import ConfClase1 from './conf/confclase1';
import ConfClase2 from './conf/confclase2';
import AddClase1 from './conf/addclase1';
import AddClase2 from './conf/addclase2';
import VerCla1 from './conf/vercla1';
import VerCla2 from './conf/vercla2';

import ConfTiTe1 from './conf/conftite1';
import ConfTiTe2 from './conf/conftite2';
import AddTiTe1 from './conf/addtite1';
import AddTiTe2 from './conf/addtite2';
import VerTiTe1 from './conf/vertite1';
import VerTiTe2 from './conf/vertite2';

import ConfSubclase1 from './conf/confsubclase1';
import ConfSubclase2 from './conf/confsubclase2';
import AddSubclase1 from './conf/addsubclase1';
import AddSubclase2 from './conf/addsubclase2';
import VerScl1 from './conf/verscl1';
import VerScl2 from './conf/verscl2';

import ConfTire1 from './conf/conftire1';
import ConfTire2 from './conf/conftire2';
import AddTire1 from './conf/addtire1';
import AddTire2 from './conf/addtire2';
import VerTire1 from './conf/vertire1';
import VerTire2 from './conf/vertire2';

import ConfRec1 from './conf/confrec1';
import ConfRec2 from './conf/confrec2';
import AddRec1 from './conf/addrec1';
import AddRec2 from './conf/addrec2';
import VerRec1 from './conf/verrec1';
import VerRec2 from './conf/verrec2';

import ConfTios1 from './conf/conftios1';
import ConfTios2 from './conf/conftios2';
import AddTios1 from './conf/addtios1';
import AddTios2 from './conf/addtios2';
import VerTios1 from './conf/vertios1';
import VerTios2 from './conf/vertios2';

import ConfClOST1 from './conf/confclost1';
import ConfClOST2 from './conf/confclost2';
import AddClOST1 from './conf/addclost1';
import AddClOST2 from './conf/addclost2';
import VerClOST1 from './conf/verclost1';
import VerClOST2 from './conf/verclost2';

import ConfCaOST1 from './conf/confcaost1';
import ConfCaOST2 from './conf/confcaost2';
import AddCaOST1 from './conf/addcaost1';
import AddCaOST2 from './conf/addcaost2';
import VerCaOST1 from './conf/vercaost1';
import VerCaOST2 from './conf/vercaost2';

import ConfEqu1 from './conf/confequ1';
import ConfEqu2 from './conf/confequ2';
import AddEqu1 from './conf/addequ1';
import AddEqu2 from './conf/addequ2';
import VerEqu1 from './conf/verequ1';
import VerEqu2 from './conf/verequ2';

import ConfClaseEqu1 from './conf/confclaseeq1';
import ConfClaseEqu2 from './conf/confclaseeq2';
import AddClaseEqu1 from './conf/addclaseeq1';
import AddClaseEqu2 from './conf/addclaseeq2';
import VerClaseEqu1 from './conf/verclaseeq1';
import VerClaseEqu2 from './conf/verclaseeq2';

import ConfMarcaEqu1 from './conf/confmarcaeq1';
import ConfMarcaEqu2 from './conf/confmarcaeq2';
import AddMarcaEqu1 from './conf/addmarcaeq1';
import AddMarcaEqu2 from './conf/addmarcaeq2';
import VerMarcaEqu1 from './conf/vermarcaeq1';
import VerMarcaEqu2 from './conf/vermarcaeq2';

import ConfFabriEqu1 from './conf/conffabrieq1';
import ConfFabriEqu2 from './conf/conffabrieq2';
import AddFabriEqu1 from './conf/addfabrieq1';
import AddFabriEqu2 from './conf/addfabrieq2';
import VerFabriEqu1 from './conf/verfabrieq1';
import VerFabriEqu2 from './conf/verfabrieq2';

import ConfBodega1 from './conf/confbodega1';
import ConfBodega2 from './conf/confbodega2';
import AddBodega1 from './conf/addbodega1';
import AddBodega2 from './conf/addbodega2';
import VerBodega1 from './conf/verbodega1';
import VerBodega2 from './conf/verbodega2';

import ConfImpto1 from './conf/confimpto1';
import ConfImpto2 from './conf/confimpto2';
import AddImpto1 from './conf/addimpto1';
import AddImpto2 from './conf/addimpto2';
import VerImpto1 from './conf/verimpto1';
import VerImpto2 from './conf/verimpto2';

import ConfTar1 from './conf/conftar1';
import ConfTar2 from './conf/conftar2';
import AddTar1 from './conf/addtar1';
import AddTar2 from './conf/addtar2';
import VerTar1 from './conf/vertar1';
import VerTar2 from './conf/vertar2';

import ConfSerT1 from './conf/confsert1';
import ConfSerT2 from './conf/confsert2';

import ConfSerTI1 from './conf/confserti1';
import ConfSerTI2 from './conf/confserti2';

import ConfOfer1 from './conf/confofer1';
import ConfOfer2 from './conf/confofer2';
import AddOfer1 from './conf/addofer1';
import AddOfer2 from './conf/addofer2';
import VerOfer1 from './conf/verofer1';
import VerOfer2 from './conf/verofer2';

import ConfSerO1 from './conf/confsero1';
import ConfSerO2 from './conf/confsero2';

import VerParam1 from './conf/verparam1';
import VerParam2 from './conf/verparam2';

import ConfBD1 from './conf/confbd1';
import ConfBD2 from './conf/confbd2';
import AddBD1 from './conf/addbd1';
import AddBD2 from './conf/addbd2';
import VerBD1 from './conf/verbd1';
import VerBD2 from './conf/verbd2';

class HomeConf extends React.Component{
  state={
    showConf: true,
    showServicio: false, addServicio: false, verServicio: false,
    showClase: false, addClase: false, verClase:false,
    showSubclase: false, addSubclase: false, verSubclase: false,
    showTiTe: false, addTiTe: false, verTiTe:false,
    showEquipo: false, addEquipo: false, verEquipo: false,
    showClaseEqu: false, addClaseEqu: false, verClaseEqu: false,
    showMarcaEqu: false, addMarcaEqu: false, verMarcaEqu: false,
    showFabriEqu: false, addFabriEqu: false, verFabriEqu: false,
    showBodega: false, addBodega: false, verBodega: false,
    showTipoos: false, addTipoos: false, verTipoos: false,
    showClasifTipoos: false, addClasifTipoos: false, verClasifTipoos: false,
    showCategTipoos: false, addCategTipoos: false, verCategTipoos: false,
    showImpto: false, addImpto: false, verImpto: false,
    showTarifa: false, addTarifa: false, verTarifa: false,
    showSerTar: false, showSerTarI: false,
    showOferta: false, addOferta: false, verOferta: false, showSerOfer: false,
    showTiporec: false, addTiporec: false, verTiporec: false,
    showRecurso: false, addRecurso: false, verRecurso: false,
    showParametro: false, stEntro: 0,
    showBD: false, addBD: false, verBD: false,
    permiteUpdate: false, permiteDelete: false,
    argsAdd: {}, errorAdd: [],
    idLista: {},
    lisServTar: [], lisServ: [], lisServTarIni: [], lisServIni: [], lisServTarI: [], lisServTarIniI: [],
  }

  crudBD = async (operacionCRUD, args)=>{
// console.log("CRUD")
if(args.ctrlCampo === 'CRUD'){
  // console.log(i)
  // console.log(args)
      const {data} = await operacionCRUD({
        variables: args
      });
  //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        // console.log("MANY")
        // console.log(args)
        await operacionCRUD({
          variables: args
        });
        // console.log("11")
      }
    }
  }
    
      updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    //ENVIO PARA ACTUALIZAR BD
        let codigo = 0
        if(argsCrud[0].ctrl_id === 'SI_ID'){
          codigo = await this.crudBD(crudColecc[0], argsCrud[0])
        }else{
          await this.crudBD(crudColecc[0], argsCrud[0])
        }
        if(codigo!==0){
          for(let i=1; i<totDocCRUD; i++){
            argsCrud[i]._id = codigo
          }
        }
        for(let i=1; i<totDocCRUD; i++){
          await this.crudBD(crudColecc[i], argsCrud[i])
        }
      }

  validarHandle = (campo1, campo1Val, campo1Sel, campo1Msg,
    campo2, campo2Val, campo2Sel, campo2Msg,
    campo3, campo3Val, campo3Sel, campo3Msg,
    campo4, campo4Val, campo4Sel, campo4Msg,
    campo5, campo5Val, campo5Sel, campo5Msg,
    campo6, campo6Val, campo6Sel, campo6Msg)=>{

    const argsAdd = this.state.argsAdd
    const errors = [];

    if(campo1!=='XXX' && (!campo1 || campo1===campo1Sel)){
      argsAdd[campo1Val] = campo1Sel;
      errors.push({path: campo1Val, message: campo1Msg});
    }
    if(campo2!=='XXX' && (!campo2 || campo2===campo2Sel)){
      argsAdd[campo2Val] = campo2Sel;
      errors.push({path: campo2Val, message: campo2Msg});
    }
    if(campo3!=='XXX' && (!campo3 || campo3===campo3Sel)){
      argsAdd[campo3Val] = campo3Sel;
      errors.push({path: campo3Val, message: campo3Msg});
    }
    if(campo4!=='XXX' && (!campo4 || campo4===campo4Sel)){
      argsAdd[campo4Val] = campo4Sel;
      errors.push({path: campo4Val, message: campo4Msg});
    }
    if(campo5!=='XXX' && (!campo5 || campo5===campo5Sel)){
      argsAdd[campo5Val] = campo5Sel;
      errors.push({path: campo5Val, message: campo5Msg});
    }
    if(campo6!=='XXX' && (!campo6 || campo6===campo6Sel)){
      argsAdd[campo6Val] = campo6Sel;
      errors.push({path: campo6Val, message: campo6Msg});
    }
    this.setState({argsAdd});
    this.setState({errorAdd: errors})
  }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        // console.log(Object.getOwnPropertyNames(this.state)[i])
        // if(typeof estado === "boolean"){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  // ordenarArrayAsc = (array, campo) => {
  //   array.sort(function (a, b) {
  //      return a[campo] > b[campo];
  //   });
  // }

  showConf = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showConf: true})
    document.body.style.cursor = 'default'
  }

  showClase = (ev) => {
    ev.preventDefault()
    this.props.allClasesServ.refetch()
    this.estadosFalse()
    this.setState({showClase: true})
  }

  showSubclase = (ev) => {
    ev.preventDefault()
    this.props.allSubclasesServ.refetch()
    this.estadosFalse()
    this.setState({showSubclase: true})
  }

  showTiTe = (ev) => {
    ev.preventDefault()
    this.props.allTipoTec.refetch()
    this.estadosFalse()
    this.setState({showTiTe: true})
  }

  showServicio = (ev) => {
    ev.preventDefault()
    this.props.allServicios.refetch()
    this.estadosFalse()
    this.setState({showServicio: true})
    document.body.style.cursor = 'default'
  }

  showTiporec = (ev) => {
    ev.preventDefault()
    this.props.allTipoRec.refetch()
    this.estadosFalse()
    this.setState({showTiporec: true})
  }

  showRecurso = (ev) => {
    ev.preventDefault()
    this.props.allRecurso.refetch()
    this.estadosFalse()
    this.setState({showRecurso: true})
  }
  
  showParametro = async (ev) => {
    ev.preventDefault()
    // console.log(this.props.getParametro.getParametro)
    // console.log(this.props.allSequence.allSequence)
    let actualizar = false
    let contratoSequence, mensajeNuevo, nuevoNumeroOSNuevo, nuevoNumeroRCNuevo, nuevoNumeroNDNuevo,
        nuevoNumeroNCNuevo, nuevoNumeroAjNuevo, nuevoNumeroDXNuevo, ajCero, prefijoFact,
        comoAsigCicloFact, impRboCaja, enPagoApp, comoAsigCargosAlCliente,
        empresaRazonSocial, empresaNit, empresaDir, empresaTel, codBarrasRdo, pagueHastaSegunSaldo,
        numMesesParaPH
    if(this.props.getParametro.getParametro){
      if(!this.props.getParametro.getParametro.contratoSequence){
        contratoSequence = "NO"
        actualizar = true
      }else{
        contratoSequence = this.props.getParametro.getParametro.contratoSequence
      }
      if(!this.props.getParametro.getParametro.mensaje){
        mensajeNuevo = "!! foroptic !!"
        actualizar = true
      }else{
        mensajeNuevo = this.props.getParametro.getParametro.mensaje
      }
      if(!this.props.getParametro.getParametro.nuevoNumeroOS){
        nuevoNumeroOSNuevo = 1
        actualizar = true
      }else{
        nuevoNumeroOSNuevo = this.props.getParametro.getParametro.nuevoNumeroOS
      }
      if(!this.props.getParametro.getParametro.nuevoNumeroRC){
        nuevoNumeroRCNuevo = 1
        actualizar = true
      }else{
        nuevoNumeroRCNuevo = this.props.getParametro.getParametro.nuevoNumeroRC
      }
      if(!this.props.getParametro.getParametro.nuevoNumeroND){
        nuevoNumeroNDNuevo = 1
        actualizar = true
      }else{
        nuevoNumeroNDNuevo = this.props.getParametro.getParametro.nuevoNumeroND
      }
      if(!this.props.getParametro.getParametro.nuevoNumeroNC){
        nuevoNumeroNCNuevo = 1
        actualizar = true
      }else{
        nuevoNumeroNCNuevo = this.props.getParametro.getParametro.nuevoNumeroNC
      }
      if(!this.props.getParametro.getParametro.nuevoNumeroAj){
        nuevoNumeroAjNuevo = 1
        actualizar = true
      }else{
        nuevoNumeroAjNuevo = this.props.getParametro.getParametro.nuevoNumeroAj
      }
      if(!this.props.getParametro.getParametro.nuevoNumeroDX){
        nuevoNumeroDXNuevo = 1
        actualizar = true
      }else{
        nuevoNumeroDXNuevo = this.props.getParametro.getParametro.nuevoNumeroDX
      }
      if(!this.props.getParametro.getParametro.ajCero){
        ajCero = 0
        actualizar = true
      }else{
        ajCero = this.props.getParametro.getParametro.ajCero
      }
      if(!this.props.getParametro.getParametro.prefijoFact){
        prefijoFact = ""
        actualizar = true
      }else{
        prefijoFact = this.props.getParametro.getParametro.prefijoFact
      }
      if(!this.props.getParametro.getParametro.comoAsigCicloFact){
        comoAsigCicloFact = "Asignarlo al crear o modificar clientes"
        actualizar = true
      }else{
        comoAsigCicloFact = this.props.getParametro.getParametro.comoAsigCicloFact
      }
      if(!this.props.getParametro.getParametro.impRboCaja){
        impRboCaja = "Tamaño carta"
        actualizar = true
      }else{
        impRboCaja = this.props.getParametro.getParametro.impRboCaja
      }
      if(!this.props.getParametro.getParametro.enPagoApp){
        enPagoApp = "Enviar mensaje por WhatsApp"
        actualizar = true
      }else{
        enPagoApp = this.props.getParametro.getParametro.enPagoApp
      }
      if(!this.props.getParametro.getParametro.comoAsigCargosAlCliente){
        comoAsigCargosAlCliente = "Hacer los cargos al cliente al cerrar las Ordenes de Servicio"
        actualizar = true
      }else{
        comoAsigCargosAlCliente = this.props.getParametro.getParametro.comoAsigCargosAlCliente
      }
      if(!this.props.getParametro.getParametro.empresaRazonSocial){
        empresaRazonSocial = ""
        actualizar = true
      }else{
        empresaRazonSocial = this.props.getParametro.getParametro.empresaRazonSocial
      }
      if(!this.props.getParametro.getParametro.empresaNit){
        empresaNit = ""
        actualizar = true
      }else{
        empresaNit = this.props.getParametro.getParametro.empresaNit
      }
      if(!this.props.getParametro.getParametro.empresaDir){
        empresaDir = ""
        actualizar = true
      }else{
        empresaDir = this.props.getParametro.getParametro.empresaDir
      }
      if(!this.props.getParametro.getParametro.empresaTel){
        empresaTel = ""
        actualizar = true
      }else{
        empresaTel = this.props.getParametro.getParametro.empresaTel
      }
      if(!this.props.getParametro.getParametro.codBarrasRdo){
        codBarrasRdo = ""
        actualizar = true
      }else{
        codBarrasRdo = this.props.getParametro.getParametro.codBarrasRdo
      }
      if(!this.props.getParametro.getParametro.pagueHastaSegunSaldo){
        pagueHastaSegunSaldo = false
        actualizar = true
      }else{
        pagueHastaSegunSaldo = this.props.getParametro.getParametro.pagueHastaSegunSaldo
      }
      if(!this.props.getParametro.getParametro.numMesesParaPH){
        numMesesParaPH = 0
        actualizar = true
      }else{
        numMesesParaPH = this.props.getParametro.getParametro.numMesesParaPH
      }

      if(actualizar){
        const argsUpd = {
          _id: this.props.getParametro.getParametro._id,
          contratoSequence: contratoSequence,
          mensaje: mensajeNuevo,
          nuevoNumeroOS: nuevoNumeroOSNuevo,
          nuevoNumeroRC: nuevoNumeroRCNuevo,
          nuevoNumeroND: nuevoNumeroNDNuevo,
          nuevoNumeroNC: nuevoNumeroNCNuevo,
          nuevoNumeroAj: nuevoNumeroAjNuevo,
          nuevoNumeroDX: nuevoNumeroDXNuevo,
          ajCero: ajCero,
          prefijoFact: prefijoFact,
          comoAsigCicloFact: comoAsigCicloFact,
          impRboCaja: impRboCaja,
          enPagoApp: enPagoApp,
          comoAsigCargosAlCliente: comoAsigCargosAlCliente,
          empresaRazonSocial: empresaRazonSocial,
          empresaNit: empresaNit,
          empresaDir: empresaDir,
          empresaTel: empresaTel,
          codBarrasRdo: codBarrasRdo,
          pagueHastaSegunSaldo: pagueHastaSegunSaldo,
          numMesesParaPH: numMesesParaPH
        }
        const response = await this.props.editParametro({
          variables: argsUpd
        });
        const {success} = response.data.editParametro;
        if (success){
          this.props.getParametro.refetch()
        }

      }else{
        this.props.getParametro.refetch()
      }
    }else{
      const args = {
        contratoSequence: "NO",
        mensaje: "!! foroptic !!",
        nuevoNumeroOS: 1,
        nuevoNumeroRC: 1,
        nuevoNumeroND: 1,
        nuevoNumeroNC: 1,
        nuevoNumeroAj: 1,
        nuevoNumeroDX: 1,
        ajCero: 0,
        prefijoFact: "",
        comoAsigCicloFact: "Asignarlo al crear o modificar clientes",
        impRboCaja: "Tamaño carta",
        enPagoApp: "Enviar mensaje por WhatsApp",
        comoAsigCargosAlCliente: "Hacer los cargos al cliente en el proceso de facturación",
        empresaRazonSocial: "",
        empresaNit: "",
        empresaDir: "",
        empresaTel: "",
        codBarrasRdo: "",
        pagueHastaSegunSaldo: true,
        numMesesParaPH: 3
      }
      this.props.createParametro({
        variables: args
      });
    }

    let seqColecc = this.props.allSequence.allSequence.filter(coleccion => coleccion.coleccion==="odess");
    if(seqColecc.length===0){
      const args = {
        coleccion: "odess",
        seq: 1,
      }
      this.props.createSequence({
        variables: args
      });
    }

    seqColecc = this.props.allSequence.allSequence.filter(coleccion => coleccion.coleccion==="reccajas");
    if(seqColecc.length===0){
      const args = {
        coleccion: "reccajas",
        seq: 1,
      }
      this.props.createSequence({
        variables: args
      });
    }

    seqColecc = this.props.allSequence.allSequence.filter(coleccion => coleccion.coleccion==="nds");
    if(seqColecc.length===0){
      const args = {
        coleccion: "nds",
        seq: 1,
      }
      this.props.createSequence({
        variables: args
      });
    }

    seqColecc = this.props.allSequence.allSequence.filter(coleccion => coleccion.coleccion==="ncs");
    if(seqColecc.length===0){
      const args = {
        coleccion: "ncs",
        seq: 1,
      }
      this.props.createSequence({
        variables: args
      });
    }

    seqColecc = this.props.allSequence.allSequence.filter(coleccion => coleccion.coleccion==="aju");
    if(seqColecc.length===0){
      const args = {
        coleccion: "aju",
        seq: 1,
      }
      this.props.createSequence({
        variables: args
      });
    }

    seqColecc = this.props.allSequence.allSequence.filter(coleccion => coleccion.coleccion==="dxm");
    if(seqColecc.length===0){
      const args = {
        coleccion: "dxm",
        seq: 1,
      }
      this.props.createSequence({
        variables: args
      });
    }

    this.estadosFalse()
    this.setState({showParametro: true})
  }

  showEquipo = (ev) => {
    ev.preventDefault()
    this.props.allEquipo.refetch()
    this.estadosFalse()
    this.setState({showEquipo: true})
  }

  showClaseEqu = (ev) => {
    ev.preventDefault()
    this.props.allClaseEqu.refetch()
    this.estadosFalse()
    this.setState({showClaseEqu: true})
  }

  showMarcaEqu = (ev) => {
    ev.preventDefault()
    this.props.allMarcaEqu.refetch()
    this.estadosFalse()
    this.setState({showMarcaEqu: true})
  }

  showFabriEqu = (ev) => {
    ev.preventDefault()
    this.props.allFabriEqu.refetch()
    this.estadosFalse()
    this.setState({showFabriEqu: true})
  }

  showBodega = (ev) => {
    ev.preventDefault()
    this.props.allBodega.refetch()
    this.estadosFalse()
    this.setState({showBodega: true})
  }

  showTipoos = (ev) => {
    ev.preventDefault()
    this.props.allTiposOS.refetch()
    this.estadosFalse()
    this.setState({showTipoos: true})
  }

  showClasifTipoos = (ev) => {
    ev.preventDefault()
    this.props.allClasifOST.refetch()
    this.estadosFalse()
    this.setState({showClasifTipoos: true})
  }

  showCategTipoos = (ev) => {
    ev.preventDefault()
    this.props.allCategOST.refetch()
    this.estadosFalse()
    this.setState({showCategTipoos: true})
  }

  showImpto = (ev) => {
    ev.preventDefault()
    this.props.allImpto.refetch()
    this.estadosFalse()
    this.setState({showImpto: true})
  }

  showBD = (ev) => {
    ev.preventDefault()
    this.props.allBaseDat.refetch()
    this.estadosFalse()
    this.setState({showBD: true})
  }

  showTarifa = (ev) => {
    ev.preventDefault()
    this.props.allTarifa.refetch()
    this.estadosFalse()
    this.setState({showTarifa: true})
  }

  showOferta = (ev) => {
    ev.preventDefault()
    this.props.allOferta.refetch()
    this.estadosFalse()
    this.setState({showOferta: true})
  }

  showSerTar = (ev) => {
    ev.preventDefault()
    this.props.allTarifa.refetch()
    this.estadosFalse()
    this.setState({showSerTar: true})
    // console.log(this.props.allTarifa.allTarifa)

    let lisServTar = [];
    let lisServTarIni = []
    let elemento2 = this.state.idLista.servicios
    // console.log(elemento2)
    elemento2.forEach((elemento, i) => {
      lisServTar.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
        rango1NumServValorIni: elemento.rango1NumServValorIni, rango1NumServValorFin: elemento.rango1NumServValorFin, rango1Valor: elemento.rango1Valor,
        rango2NumServValorIni: elemento.rango2NumServValorIni, rango2NumServValorFin: elemento.rango2NumServValorFin, rango2Valor: elemento.rango2Valor,
        rango3NumServValorIni: elemento.rango3NumServValorIni, rango3NumServValorFin: elemento.rango3NumServValorFin, rango3Valor: elemento.rango3Valor,
        velEfecDownstream: elemento.velEfecDownstream,
        velEfecUpstream: elemento.velEfecUpstream,
        codigoTipoTec: elemento.codigoTipoTec,
        descrTipoTec: elemento.descrTipoTec,
        colorServicio: elemento.colorServicio,
        _id: i, estadoServ: true});

      lisServTarIni.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
        rango1NumServValorIni: elemento.rango1NumServValorIni, rango1NumServValorFin: elemento.rango1NumServValorFin, rango1Valor: elemento.rango1Valor,
        rango2NumServValorIni: elemento.rango2NumServValorIni, rango2NumServValorFin: elemento.rango2NumServValorFin, rango2Valor: elemento.rango2Valor,
        rango3NumServValorIni: elemento.rango3NumServValorIni, rango3NumServValorFin: elemento.rango3NumServValorFin, rango3Valor: elemento.rango3Valor,
        velEfecDownstream: elemento.velEfecDownstream,
        velEfecUpstream: elemento.velEfecUpstream,
        codigoTipoTec: elemento.codigoTipoTec,
        descrTipoTec: elemento.descrTipoTec,
        colorServicio: elemento.colorServicio,
        _id: i, estadoServ: true});
      })

      lisServTar = _.orderBy(lisServTar, ['descrClaseServ', 'descripcionServicio'])
      this.setState({lisServTar})

      lisServTarIni = _.orderBy(lisServTarIni, ['descrClaseServ', 'descripcionServicio'])
      this.setState({lisServTarIni})

    let lisServ = [];
    let lisServIni = [];
    elemento2 = this.props.allServicios.allServicios
    elemento2.forEach((elemento, _id) => {
      let siExiste = false
      lisServTar.forEach((elemento1, _id) => {
        if(elemento.codigoServicio===elemento1.codigoServicio){
          siExiste = true
        }
      })
      if(siExiste===false){
        lisServ.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
          nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
          velEfecDownstream: elemento.velEfecDownstream, velEfecUpstream: elemento.velEfecUpstream,
          codigoTipoTec: elemento.codigoTipoTec, descrTipoTec: elemento.descrTipoTec,
          colorServicio: elemento.colorServicio,
          _id: elemento._id, estadoServ: false});

          lisServIni.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
          _id: elemento._id, estadoServ: false});
      }
    })

    lisServ = _.orderBy(lisServ, ['descrClaseServ', 'descripcionServicio'])
    this.setState({lisServ})

    lisServIni = _.orderBy(lisServIni, ['descrClaseServ', 'descripcionServicio'])
    this.setState({lisServIni})
  }
  
  showSerTarI = (ev) => {
    ev.preventDefault()
    this.props.allTarifa.refetch()
    this.estadosFalse()
    this.setState({showSerTarI: true})

    let lisServTarI = [];
    let lisServTarIniI = []
    let elemento2 = this.state.idLista.servicios
    elemento2.forEach((elemento, i) => {
      if(elemento.imptos.length>0){
        elemento.imptos.forEach((elemento1, _id) => {
          lisServTarI.push({_id: lisServTarI.length, codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
            idImpto: elemento1._id, codigoImpto: elemento1.codigoImpto,
            descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
            estadoServ: true});

            lisServTarIniI.push({_id: lisServTarI.length, codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
            idImpto: elemento1._id, codigoImpto: elemento1.codigoImpto,
            descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
            estadoServ: true});
        })
      }else{
        lisServTarI.push({_id: lisServTarI.length, codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
          idImpto: null, codigoImpto: null,
          descrImpto: null, porcImpto: null,
          estadoServ: true});

          lisServTarIniI.push({_id: lisServTarI.length, codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
            idImpto: null, codigoImpto: null,
            descrImpto: null, porcImpto: null,
            estadoServ: true});
    }
    })
    lisServTarI = _.orderBy(lisServTarI, ['descrClaseServ', 'descripcionServicio'])
    this.setState({lisServTarI})

    lisServTarIniI = _.orderBy(lisServTarIniI, ['descrClaseServ', 'descripcionServicio'])
    this.setState({lisServTarIniI})
  }

  showSerOfer = (ev) => {
    ev.preventDefault()
    this.props.allOferta.refetch()
    this.estadosFalse()
    this.setState({showSerOfer: true})

    let lisServTar = [];
    let lisServTarIni = []
    let elemento2 = this.state.idLista.servicios
    elemento2.forEach((elemento, i) => {
      lisServTar.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
        porcDctoOferta: elemento.porcDctoOferta, numDiasOferta: elemento.numDiasOferta,
        _id: i, estadoServ: true});

      lisServTarIni.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
        porcDctoOferta: elemento.porcDctoOferta, numDiasOferta: elemento.numDiasOferta,
        _id: i, estadoServ: true});
      })
      lisServTar = _.orderBy(lisServTar, ['descrClaseServ', 'descripcionServicio'])
      this.setState({lisServTar})

      lisServTarIni = _.orderBy(lisServTarIni, ['descrClaseServ', 'descripcionServicio'])
      this.setState({lisServTarIni})

    let lisServ = [];
    let lisServIni = [];
    elemento2 = this.props.allServicios.allServicios
    elemento2.forEach((elemento, _id) => {
      let siExiste = false
      lisServTar.forEach((elemento1, _id) => {
        if(elemento.codigoServicio===elemento1.codigoServicio){
          siExiste = true
        }
      })
      if(siExiste===false){
        lisServ.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
          _id: elemento._id, estadoServ: false});

          lisServIni.push({codigoServicio: elemento.codigoServicio, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
          _id: elemento._id, estadoServ: false});
      }
    })

    lisServ = _.orderBy(lisServ, ['descrClaseServ', 'descripcionServicio'])
    this.setState({lisServ})

    lisServIni = _.orderBy(lisServIni, ['descrClaseServ', 'descripcionServicio'])
    this.setState({lisServIni})
  }

  addClase = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addClase: true})
  }

  addSubclase = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addSubclase: true})
  }

  addTiTe = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTiTe: true})
  }

  addServicio = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addServicio: true})
  }

  addTiporec = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTiporec: true})
  }

  selCiudad = () => {
    if(this.props.allDirmayor.allDirmayor){
      if(this.props.codigoCiudadUA!=="Todas..."){
        const argsAdd = this.state.argsAdd
        let dptoOK = false
        this.props.allDirmayor.allDirmayor.forEach((elemento, _id) => {
          if(!dptoOK){
            elemento.ciudades.forEach((elemento1, _id) => {
              if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                dptoOK = true
                argsAdd['_idDpto'] = elemento._id
                argsAdd['codigoDpto'] = elemento.codigoDpto
                argsAdd['descrDpto'] = elemento.descrDpto
                argsAdd['codigoCiudad'] = elemento1.codigoCiudad
                argsAdd['nombreCiudad'] = elemento1.nombreCiudad                
                this.setState({argsAdd});
                // console.log(argsAdd)
              }
            })
          }
        })
        // console.log(argsAdd)
      }
      // console.log(lista1)
    }
  }

  addRecurso = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addRecurso: true})

    this.selCiudad()
  }

  addEquipo = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addEquipo: true})
  }

  addClaseEqu = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addClaseEqu: true})
  }

  addMarcaEqu = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addMarcaEqu: true})
  }

  addFabriEqu = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addFabriEqu: true})
  }

  addBodega = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addBodega: true})
  }

  addTipoos = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTipoos: true})
  }

  addClasifTipoos = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addClasifTipoos: true})
  }

  addCategTipoos = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addCategTipoos: true})
  }

  addImpto = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addImpto: true})
  }

  addBD = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addBD: true})
  }

  addTarifa = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTarifa: true})

    const argsAdd = this.state.argsAdd
    argsAdd['estadoTarifa'] = false
    this.setState({argsAdd});
  }

  addOferta = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addOferta: true})

    const argsAdd = this.state.argsAdd
    argsAdd['estadoOferta'] = false
    this.setState({argsAdd});
  }

  verTarifa = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({verTarifa: true})
  }

  verOferta = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({verOferta: true})
  }

  handleChange = (ev, input)=>{
    const argsAdd = this.state.argsAdd
    if(ev.target.type==='checkbox'){
      argsAdd[ev.target.name] = ev.target.checked
    }else{
      argsAdd[ev.target.name] = ev.target.value
    }
    //   if(input.type==='checkbox'){
    //   argsAdd[input.name] = input.checked
    // }else{
    //   argsAdd[input.name] = input.value
    // }
    this.setState({argsAdd});
  }

  handleServicio = async (ev, args)=>{
    // console.log(args)
    if(!args.codigoServicio||!args.nombreResumido||!args.descripcionServicio||!args.conceptoEnFra||
      !args.consecEnFra||!args.descrSubclaseServ||args.descrSubclaseServ==="Seleccionar..."||
      !args.descrTipoTec||args.descrTipoTec==="Seleccionar..."||
      !args.paraProcMasDX||args.paraProcMasDX==="Seleccionar..."){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoServicio){
        argsAdd['codigoServicio'] = "";
        errors.push({path: 'codigoServicio', message: "Debe escribir el código"});
      }
      if(!args.nombreResumido){
        argsAdd['nombreResumido'] = "";
        errors.push({path: 'nombreResumido', message: "Debe escribir la descripción resumida"});
      }
      if(!args.descripcionServicio){
        argsAdd['descripcionServicio'] = "";
        errors.push({path: 'descripcionServicio', message: "Debe escribir la descripción"});
      }
      if(!args.conceptoEnFra){
        argsAdd['conceptoEnFra'] = "";
        errors.push({path: 'conceptoEnFra', message: "Debe escribir el concepto para la factura"});
      }
      if(!args.consecEnFra){
        argsAdd['consecEnFra'] = "";
        errors.push({path: 'consecEnFra', message: "Debe escribir el consecutivo para la factura"});
      }
      if(!args.descrSubclaseServ||args.descrSubclaseServ==="Seleccionar..."){
        argsAdd['_idSubclaseServ'] = "";
        argsAdd['descrSubclaseServ'] = "Seleccionar...";
        errors.push({path: 'Subclase', message: "Debe seleccionar la subclase"});
      }
      if(!args.descrTipoTec||args.descrTipoTec==="Seleccionar..."){
        argsAdd['descrTipoTec'] = "Seleccionar...";
        errors.push({path: 'TipoTec', message: "Debe seleccionar el tipo de tecnología"});
      }
      if(!args.paraProcMasDX||args.paraProcMasDX==="Seleccionar..."){
        argsAdd['paraProcMasDX'] = "Seleccionar...";
        errors.push({path: 'paraProcMasDX', message: "Debe indicar si el servicio se puede seleccionar en proceso de DX masiva"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addServicio){
        if(this.props.allServicios.allServicios){
          let indexSearch = await this.props.allServicios.allServicios.findIndex( servicio => servicio.descripcionServicio === args.descripcionServicio );
          if(indexSearch!==-1){
            const errors = [];
            errors.push({path: 'descripcionServicio', message: "El servicio" + args.descripcionServicio + " YA existe"});
            this.setState({errorAdd: errors})
          }else{
            // console.log(args)
            if(!args.velEfecDownstream){
              args['velEfecDownstream'] = "0"
            }
            if(!args.velEfecUpstream){
              args['velEfecUpstream'] = "0"
            }
            if(!args.colorServicio){
              args['colorServicio'] = "#ffffff"
            }
            // console.log(args)
            const response = await this.props.createServicio({
              variables: args
            });
            const {errors, success} = response.data.createServicio;
            if (!success){
              this.setState({errorAdd: errors})
            }else{
              var codigoServicio = document.getElementById("codigoServicio");
              var nombreResumido = document.getElementById("nombreResumido");
              var descripcionServicio = document.getElementById("descripcionServicio");
              var conceptoEnFra = document.getElementById("conceptoEnFra");
              var consecEnFra = document.getElementById("consecEnFra");
              var subclase = document.getElementById("miLista");
              subclase.options.selectedIndex = 0
              var velEfecDownstream = document.getElementById("velEfecDownstream");
              var velEfecUpstream = document.getElementById("velEfecUpstream");
              var colorServicio = document.getElementById("colorServicio");
              var tipotec = document.getElementById("miListaTT");
              tipotec.options.selectedIndex = 0
              var paraProcMasDX = document.getElementById("miLista7");
              paraProcMasDX.options.selectedIndex = 0

              codigoServicio.value = ""
              nombreResumido.value = ""
              descripcionServicio.value = ""
              conceptoEnFra.value = ""
              consecEnFra.value = ""
              velEfecDownstream.value = ""
              velEfecUpstream.value = ""
              colorServicio.value = "#ffffff"
              this.setState({errorAdd: []})
              this.setState({argsAdd: {}})
              this.props.allServicios.refetch()
            }
          }
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            codigoServicio: args.codigoServicio,
            nombreResumido: args.nombreResumido,
            descripcionServicio: args.descripcionServicio,
            conceptoEnFra: args.conceptoEnFra,
            consecEnFra: args.consecEnFra,
            paraProcMasDX: args.paraProcMasDX,
            velEfecDownstream: args.velEfecDownstream,
            velEfecUpstream: args.velEfecUpstream,
            codigoTipoTec: args.codigoTipoTec,
            descrTipoTec: args.descrTipoTec,
            colorServicio: args.colorServicio,
          }
          // console.log(argsUpd)
          document.body.style.cursor = 'wait'
          const response = await this.props.editServicio({
            variables: argsUpd
          });
          const {errors, success} = response.data.editServicio;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allServicios.refetch()
            this.estadosFalse()
            this.setState({showServicio: true})
          }
          document.body.style.cursor = 'default'
        }
        if(this.state.permiteDelete){
          const argsDel = {
            "_id": args._id,
            "codigoServicio": args.codigoServicio
          }
          const response = await this.props.deleteServicio({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteServicio;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allServicios.refetch()
            this.estadosFalse()
            this.setState({showServicio: true})
          }
        }
      }
    }
  }

  handleClase = async (ev, args)=>{
    if(!args.codigoClaseServ||!args.descrClaseServ){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoClaseServ){
        argsAdd['codigoClaseServ'] = "";
        errors.push({path: 'codigoClaseServ', message: "Debe escribir el código"});
      }
      if(!args.descrClaseServ){
        argsAdd['descrClaseServ'] = "";
        errors.push({path: 'descrClaseServ', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addClase){
        const response = await this.props.createClaseServ({
          variables: args
        });
        const {errors, success} = response.data.createClaseServ;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoClaseServ = document.getElementById("codigoClaseServ");
          var descrClaseServ = document.getElementById("descrClaseServ");
          codigoClaseServ.value = ""
          descrClaseServ.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allClasesServ.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrClaseServ: args.descrClaseServ
          }
          const response = await this.props.editClaseServ({
            variables: argsUpd
          });
          const {errors, success} = response.data.editClaseServ;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allClasesServ.refetch()
            this.estadosFalse()
            this.setState({showClase: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            "_id": args._id,
            "codigoClaseServ": args.codigoClaseServ
          }
          const response = await this.props.deleteClaseServ({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteClaseServ;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allClasesServ.refetch()
            this.estadosFalse()
            this.setState({showClase: true})
          }
        }
      }
    }
  }

  handleSubclase = async (ev, args)=>{
    if(!args.codigoSubclaseServ||!args.descrSubclaseServ||!args.descrClaseServ||args.descrClaseServ==="Seleccionar..."){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoSubclaseServ){
        argsAdd['codigoSubclaseServ'] = "";
        errors.push({path: 'codigoSubclaseServ', message: "Debe escribir el código"});
      }
      if(!args.descrSubclaseServ){
        argsAdd['descrSubclaseServ'] = "";
        errors.push({path: 'descrSubclaseServ', message: "Debe escribir la descripción"});
      }
      if(!args.descrClaseServ||args.descrClaseServ==="Seleccionar..."){
        argsAdd['_idClaseserv'] = "";
        argsAdd['descrClaseServ'] = "Seleccionar...";
        errors.push({path: 'Clase', message: "Debe seleccionar la clase"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addSubclase){
        const response = await this.props.createSubclaseServ({
          variables: args
        });
        const {errors, success} = response.data.createSubclaseServ;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoSubclaseServ = document.getElementById("codigoSubclaseServ");
          var descrSubclaseServ = document.getElementById("descrSubclaseServ");
          var clase = document.getElementById("miLista");
          clase.options.selectedIndex = 0
          codigoSubclaseServ.value = ""
          descrSubclaseServ.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allSubclasesServ.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            codigoSubclaseServ: args.codigoSubclaseServ,
            descrSubclaseServ: args.descrSubclaseServ,
            idClase: args.idClase,
            codigoClaseServ: args.codigoClaseServ,
            descrClaseServ: args.descrClaseServ,
          }
          const response = await this.props.editSubclaseServ({
            variables: argsUpd
          });
          const {errors, success} = response.data.editSubclaseServ;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allSubclasesServ.refetch()
            this.estadosFalse()
            this.setState({showSubclase: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            "_id": args._id,
            "codigoSubclaseServ": args.codigoSubclaseServ
          }
          const response = await this.props.deleteSubclaseServ({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteSubclaseServ;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allSubclasesServ.refetch()
            this.estadosFalse()
            this.setState({showSubclase: true})
          }
        }
      }
    }
  }

  handleTipoTec = async (ev, args)=>{
    if(!args.codigoTipoTec||!args.descrTipoTec){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoTipoTec){
        argsAdd['codigoTipoTec'] = "";
        errors.push({path: 'codigoTipoTec', message: "Debe escribir el código"});
      }
      if(!args.descrTipoTec){
        argsAdd['descrTipoTec'] = "";
        errors.push({path: 'descrTipoTec', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addTiTe){
        const response = await this.props.createTipoTec({
          variables: args
        });
        const {errors, success} = response.data.createTipoTec;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoTipoTec = document.getElementById("codigoTipoTec");
          var descrTipoTec = document.getElementById("descrTipoTec");
          codigoTipoTec.value = ""
          descrTipoTec.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allTipoTec.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            codigoTipoTec: args.codigoTipoTec,
            descrTipoTec: args.descrTipoTec
          }
          const response = await this.props.editTipoTec({
            variables: argsUpd
          });
          const {errors, success} = response.data.editTipoTec;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTipoTec.refetch()
            this.estadosFalse()
            this.setState({showTiTe: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            "_id": args._id,
            "codigoTipoTec": args.codigoTipoTec
          }
          const response = await this.props.deleteTipoTec({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteTipoTec;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTipoTec.refetch()
            this.estadosFalse()
            this.setState({showTiTe: true})
          }
        }
      }
    }
  }

  handleTiporec = async (ev, args)=>{
    if(!args.descrTipoRec||!args.areaAprovech||args.areaAprovech==="Seleccionar..."){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrTipoRec){
        argsAdd['descrTipoRec'] = "";
        errors.push({path: 'descrTipoRec', message: "Debe escribir la descripción"});
      }
      if(!args.areaAprovech||args.areaAprovech==="Seleccionar..."){
        argsAdd['areaAprovech'] = "Seleccionar...";
        errors.push({path: 'areaAprovech', message: "Debe seleccionar el área de aprovechamiento"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addTiporec){
        const response = await this.props.createTipoRec({
          variables: args
        });
        const {errors, success} = response.data.createTipoRec;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrTipoRec = document.getElementById("descrTipoRec");
          var areaaprovech = document.getElementById("miLista");
          areaaprovech.options.selectedIndex = 0
          descrTipoRec.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allTipoRec.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          document.body.style.cursor = 'wait'
          const argsUpd = {
            _id: args._id,
            descrTipoRec: args.descrTipoRec,
            areaAprovech: args.areaAprovech,
          }
          const response = await this.props.editTipoRec({
            variables: argsUpd
          });
          const {errors, success} = response.data.editTipoRec;
          document.body.style.cursor = 'default'
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTipoRec.refetch()
            this.estadosFalse()
            this.setState({showTiporec: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            "_id": args._id,
            "descrTipoRec": args.descrTipoRec
          }
          const response = await this.props.deleteTipoRec({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteTipoRec;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTipoRec.refetch()
            this.estadosFalse()
            this.setState({showTiporec: true})
          }
        }
      }
    }
  }

  handleRecurso = async (ev, args)=>{
    // console.log(args, this.state.idLista)
    if(!args.codigoTipoDoc||args.codigoTipoDoc==="Seleccionar..."||!args.numeroDocum||!args.descrRecurso||!args.descrTipoRec||args.descrTipoRec==="Seleccionar..."){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoTipoDoc||args.codigoTipoDoc==="Seleccionar..."){
        argsAdd['codigoTipoDoc'] = "Seleccionar...";
        errors.push({path: 'TipoDoc', message: "Debe seleccionar el tipo de documento"});
      }
      if(!args.numeroDocum){
        argsAdd['numeroDocum'] = "";
        errors.push({path: 'numeroDocum', message: "Debe escribir el número de documento"});
      }
      if(!args.descrRecurso){
        argsAdd['descrRecurso'] = "";
        errors.push({path: 'descrRecurso', message: "Debe escribir la descripción"});
      }
      if(!args.descrTipoRec||args.descrTipoRec==="Seleccionar..."){
        argsAdd['_idTipoRec'] = "";
        argsAdd['descrTipoRec'] = "Seleccionar...";
        errors.push({path: 'TipoRec', message: "Debe seleccionar el tipo de recurso"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addRecurso){
        // console.log(args)
        const response = await this.props.createRecurso({
          variables: args
        });
        const {errors, success} = response.data.createRecurso;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          let numeroDocum = document.getElementById("numeroDocum");
          let descrRecurso = document.getElementById("descrRecurso");
          let telContacto = document.getElementById("telContacto");
          let dirArchIn = document.getElementById("dirArchIn");
          
          let modeloFactura=this.props.getParametro.getParametro.modeloFactura
          if(modeloFactura==="3"){
            let posIniContrato = document.getElementById("posIniContrato");
            let longContrato = document.getElementById("longContrato");
            let posIniNumeroDoc = document.getElementById("posIniNumeroDoc");
            let longNumeroDoc = document.getElementById("longNumeroDoc");
            let posIniNombre = document.getElementById("posIniNombre");
            let longNombre = document.getElementById("longNombre");
            let posIniApellido = document.getElementById("posIniApellido");
            let longApellido = document.getElementById("longApellido");
            let posIniValor = document.getElementById("posIniValor");
            let longValor = document.getElementById("longValor");
            let posIniFecha = document.getElementById("posIniFecha");
            let longFecha = document.getElementById("longFecha");
            let posIniCodCiudad = document.getElementById("posIniCodCiudad");
            let longCodCiudad = document.getElementById("longCodCiudad");
            let numPrimLinExcluir = document.getElementById("numPrimLinExcluir");
            posIniContrato.value = ""
            longContrato.value = ""
            posIniNumeroDoc.value = ""
            longNumeroDoc.value = ""
            posIniNombre.value = ""
            longNombre.value = ""
            posIniApellido.value = ""
            longApellido.value = ""
            posIniValor.value = ""
            longValor.value = ""
            posIniFecha.value = ""
            longFecha.value = ""
            posIniCodCiudad.value = ""
            longCodCiudad.value = ""
            numPrimLinExcluir.value = 0
          }

          let tipodoc = document.getElementById("miLista3");
          tipodoc.options.selectedIndex = 0
          let tiporec = document.getElementById("miLista2");
          tiporec.options.selectedIndex = 0
          let miLista = document.getElementById("miLista");
          miLista.options.selectedIndex = 0
          miLista = document.getElementById("miLista1");
          miLista.options.selectedIndex = 0
          numeroDocum.value = ""
          descrRecurso.value = ""
          telContacto.value = ""
          dirArchIn.value = ""

          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allRecurso.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            _idAnterior: this.state.idLista.tiporec._id,
            codigoTipoDoc: args.codigoTipoDoc,
            numeroDocum: args.numeroDocum,
            descrRecurso: args.descrRecurso,
            telContacto: args.telContacto,
            idTipoRec: args.idTipoRec,
            descrTipoRec: args.descrTipoRec,
            _idDpto: args._idDpto,
            codigoDpto: args.codigoDpto,
            descrDpto: args.descrDpto,
            codigoCiudad: args.codigoCiudad,
            nombreCiudad: args.nombreCiudad,
            areaAprovech: args.areaAprovech,
            dirArchIn: args.dirArchIn,
            posIniContrato: args.posIniContrato,
            longContrato: args.longContrato,
            posIniNumeroDoc: args.posIniNumeroDoc,
            longNumeroDoc: args.longNumeroDoc,
            posIniNombre: args.posIniNombre,
            longNombre: args.longNombre,
            posIniApellido: args.posIniApellido,
            longApellido: args.longApellido,
            posIniValor: args.posIniValor,
            longValor: args.longValor,
            posIniFecha: args.posIniFecha,
            longFecha: args.longFecha,
            posIniCodCiudad: args.posIniCodCiudad,
            longCodCiudad: args.longCodCiudad,
            numPrimLinExcluir: args.numPrimLinExcluir,
          }
          // console.log(argsUpd)
          const response = await this.props.editRecurso({
            variables: argsUpd
          });
          const {errors, success} = response.data.editRecurso;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allRecurso.refetch()
            this.estadosFalse()
            this.setState({showRecurso: true})

            //ACTUALIZA EN clientes
            let updDoc = [], updDocMany = [], updDocMany1 = []

            let updMatch1 = args.numeroDocum
            let updSet4 = args.descrRecurso
            let argsMatchCl1 = `'dirmayor.ciudades.zonas.barrios.numeroDocumT': '${updMatch1}'`
            let argsSetCl1 = `'dirmayor.ciudades.zonas.barrios.descrRecursoT': '${updSet4}'`
            let argsUpdCl1 = {tipoqry: `{${argsMatchCl1}}, {$set: {${argsSetCl1}}}`, modelo: 'models.Cliente.updateMany'}
            // console.log(argsUpdCl)

            let argsMatchCl2 = `'dirmayor.ciudades.zonas.barrios.numeroDocumR': '${updMatch1}'`
            let argsSetCl2 = `'dirmayor.ciudades.zonas.barrios.descrRecursoR': '${updSet4}'`
            let argsUpdCl2 = {tipoqry: `{${argsMatchCl2}}, {$set: {${argsSetCl2}}}`, modelo: 'models.Cliente.updateMany'}

            // console.log(argsUpdCl)
            // console.log(argsUpdDM)
            updDoc.push(argsUpdCl1)
            updDoc.push(argsUpdCl2)

            // console.log(updDoc)

            updDoc.forEach((elemento, ii) => {
              // console.log(elemento)
              updDocMany.push(elemento)
              updDocMany1.push({docum: updDocMany})
              updDocMany = []
            })
            // updDocMany1.push({docum: updDocMany})

            let numDocCRUD = 0, totDocCRUD = 2, argsCrud = [], crudColecc = []
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.updDocumMany)
            }
            // console.log(updDocMany1[0])
            argsCrud[numDocCRUD] = updDocMany1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.updDocumMany
            // console.log(updDocMany1[1])
            numDocCRUD += 1
            argsCrud[numDocCRUD] = updDocMany1[1]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.updDocumMany

            // console.log(argsCrud)
            await this.updColecc(crudColecc, argsCrud, totDocCRUD)
            //FIN ACTUALIZA EN clientes
          }
        }
        if(this.state.permiteDelete){
          // console.log(args)
          //Validar si el recurso esta asociado en algún Barrio
          const errors = [];
          let argsBuscarRec = {tipoqry: `[
            {$unwind: '$ciudades'},
            {$unwind: '$ciudades.zonas'},
            {$unwind: '$ciudades.zonas.barrios'},
            {$project: {numeroDocumT: '$ciudades.zonas.barrios.numeroDocumT', nombreCiudad: '$ciudades.nombreCiudad',
              nombreZona: '$ciudades.zonas.nombreZona', nombreBarrio: '$ciudades.zonas.barrios.nombreBarrio',}},
            {$match: {numeroDocumT: '${args.numeroDocum}'}}
          ]`}
          await this.props.allDirmayorRtes.refetch(argsBuscarRec)
          if(this.props.allDirmayorRtes.allDirmayorRtes.length>0){
            for(let iii=0; iii<this.props.allDirmayorRtes.allDirmayorRtes.length; iii++){
              errors.push({path: 'TipoRec', message: `${args.descrRecurso} esta asignado en el área TECNICA al barrio ${this.props.allDirmayorRtes.allDirmayorRtes[iii].nombreBarrio}, zona ${this.props.allDirmayorRtes.allDirmayorRtes[iii].nombreZona}, ciudad ${this.props.allDirmayorRtes.allDirmayorRtes[iii].nombreCiudad}`});
            }
          }
          argsBuscarRec = {tipoqry: `[
            {$unwind: '$ciudades'},
            {$unwind: '$ciudades.zonas'},
            {$unwind: '$ciudades.zonas.barrios'},
            {$project: {numeroDocumR: '$ciudades.zonas.barrios.numeroDocumR', nombreCiudad: '$ciudades.nombreCiudad',
              nombreZona: '$ciudades.zonas.nombreZona', nombreBarrio: '$ciudades.zonas.barrios.nombreBarrio',}},
            {$match: {numeroDocumR: '${args.numeroDocum}'}}
          ]`}
          await this.props.allDirmayorRtes.refetch(argsBuscarRec)
          if(this.props.allDirmayorRtes.allDirmayorRtes.length>0){
            for(let iii=0; iii<this.props.allDirmayorRtes.allDirmayorRtes.length; iii++){
              errors.push({path: 'TipoRec', message: `${args.descrRecurso} esta asignado en el área RECAUDO al barrio ${this.props.allDirmayorRtes.allDirmayorRtes[iii].nombreBarrio}, zona ${this.props.allDirmayorRtes.allDirmayorRtes[iii].nombreZona}, ciudad ${this.props.allDirmayorRtes.allDirmayorRtes[iii].nombreCiudad}`});
            }
          }
          //FIN Validar si el recurso esta asociado en algún Barrio

          if(errors.length > 0){
            this.setState({errorAdd: errors})
          }else{
            const argsDel = {
              _id: args._id
            }
            await this.props.deleteRecurso({
              variables: argsDel
            });
  
            this.props.allRecurso.refetch()
            this.estadosFalse()
            this.setState({showRecurso: true})
          }
        }
      }
    }
  }

  handleParametro = async (ev, args)=>{
    const argsAdd = this.state.argsAdd
    const errors = [];
// console.log(args)
// console.log(this.props.getParametro.getParametro.nuevoNumeroOS)
// console.log(this.props.getParametro.getParametro)

// console.log(this.state.permiteUpdate)
    if(!args.mensaje){
      if(!args.mensaje){
        argsAdd['mensaje'] = "";
        errors.push({path: 'mensaje', message: "Debe escribir el mensaje"});
        this.setState({argsAdd});
        this.setState({errorAdd: errors})
      }
    }else{
      if(this.state.permiteUpdate){
        // console.log(args)
        let argsUpd = {}
        let secuencia = this.props.allSequence.allSequence
        if(args.checkNuevoNumeroOS){
          const indexSearch = secuencia.findIndex( coleccion => coleccion.coleccion === "odess" );
          if(indexSearch!==-1){
            argsUpd = {
              coleccion: secuencia[indexSearch].coleccion,
              seq: args.nuevoNumeroOS - 1
            }
            await this.props.editSequence({
              variables: argsUpd
            });
          }
        }
        if(args.checkNuevoNumeroRC){
          const indexSearch = secuencia.findIndex( coleccion => coleccion.coleccion === "reccajas" );
          if(indexSearch!==-1){
            argsUpd = {
              coleccion: secuencia[indexSearch].coleccion,
              seq: args.nuevoNumeroRC - 1
            }
            await this.props.editSequence({
              variables: argsUpd
            });
          }
        }
        if(args.checkNuevoNumeroND){
          const indexSearch = secuencia.findIndex( coleccion => coleccion.coleccion === "nds" );
          if(indexSearch!==-1){
            argsUpd = {
              coleccion: secuencia[indexSearch].coleccion,
              seq: args.nuevoNumeroND - 1
            }
            await this.props.editSequence({
              variables: argsUpd
            });
          }
        }
        if(args.checkNuevoNumeroNC){
          const indexSearch = secuencia.findIndex( coleccion => coleccion.coleccion === "ncs" );
          if(indexSearch!==-1){
            argsUpd = {
              coleccion: secuencia[indexSearch].coleccion,
              seq: args.nuevoNumeroNC - 1
            }
            await this.props.editSequence({
              variables: argsUpd
            });
          }
        }
        if(args.checkNuevoNumeroAj){
          const indexSearch = secuencia.findIndex( coleccion => coleccion.coleccion === "aju" );
          if(indexSearch!==-1){
            argsUpd = {
              coleccion: secuencia[indexSearch].coleccion,
              seq: args.nuevoNumeroAj - 1
            }
            await this.props.editSequence({
              variables: argsUpd
            });
          }
        }

        argsUpd = {
          _id: args._id,
          contratoSequence: args.contratoSequence,
          mensaje: args.mensaje,
          nuevoNumeroOS: args.checkNuevoNumeroOS?args.nuevoNumeroOS:this.props.getParametro.getParametro.nuevoNumeroOS,
          nuevoNumeroRC: args.checkNuevoNumeroRC?args.nuevoNumeroRC:this.props.getParametro.getParametro.nuevoNumeroRC,
          nuevoNumeroND: args.checkNuevoNumeroND?args.nuevoNumeroND:this.props.getParametro.getParametro.nuevoNumeroND,
          nuevoNumeroNC: args.checkNuevoNumeroNC?args.nuevoNumeroNC:this.props.getParametro.getParametro.nuevoNumeroNC,
          nuevoNumeroAj: args.checkNuevoNumeroAj?args.nuevoNumeroAj:this.props.getParametro.getParametro.nuevoNumeroAj,
          nuevoNumeroDX: args.nuevoNumeroDX, prefijoFact: args.prefijoFact,
          comoAsigCicloFact: args.comoAsigCicloFact,
          impRboCaja: args.impRboCaja, enPagoApp: args.enPagoApp,
          ajCero: args.ajCero, 
          comoAsigCargosAlCliente: args.comoAsigCargosAlCliente, empresaRazonSocial: args.empresaRazonSocial,
          empresaNit: args.empresaNit, empresaDir: args.empresaDir, empresaTel: args.empresaTel,
          codBarrasRdo: args.codBarrasRdo, pagueHastaSegunSaldo: args.pagueHastaSegunSaldo,
          numMesesParaPH: args.numMesesParaPH
        }
        const response = await this.props.editParametro({
          variables: argsUpd
        });
        const {errors, success} = response.data.editParametro;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          this.props.getParametro.refetch()
          this.estadosFalse()
          this.setState({showConf: true})
        }
      }
    }
  }

  handleEquipo = async (ev, args)=>{
    // console.log(args)
    if((!args.numeroSerie||!args.mac||
      !args.descrClaseEqu||args.descrClaseEqu==="Seleccionar..."||
      !args.descrMarcaEqu||args.descrMarcaEqu==="Seleccionar..."||
      !args.descrFabriEqu||args.descrFabriEqu==="Seleccionar..."||
      ((!args.descrBodega||args.descrBodega==="Seleccionar...")&&this.state.addEquipo))&&!this.state.permiteDelete){

      // let sinCampo='XXX'
      this.validarHandle(args.numeroSerie, 'numeroSerie', '', 'Debe escribir el serial',
                        args.mac, 'mac', '', 'Debe escribir la mac',
                        args.descrClaseEqu, 'descrClaseEqu', 'Seleccionar...', 'Debe seleccionar la clase',
                        args.descrMarcaEqu, 'descrMarcaEqu', 'Seleccionar...', 'Debe seleccionar la marca',
                        args.descrFabriEqu, 'descrFabriEqu', 'Seleccionar...', 'Debe seleccionar el fabricante',
                        args.descrBodega, 'descrBodega', 'Seleccionar...', 'Debe seleccionar la bodega')
    }else{
      if(this.state.addEquipo){
        // console.log(args)
        let argsCre = {...args, tipoAct: "CrearEquipo"}
        console.log(argsCre)
        const response = await this.props.createEquipo({
          variables: argsCre
        });
        const {errors, success} = response.data.createEquipo;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          // var claseequ = document.getElementById("miLista");
          // claseequ.options.selectedIndex = 0
          // var marcaequ = document.getElementById("miLista1");
          // marcaequ.options.selectedIndex = 0
          // var fabriequ = document.getElementById("miLista2");
          // fabriequ.options.selectedIndex = 0
          // var bodega = document.getElementById("miLista3");
          // bodega.options.selectedIndex = 0
          var numeroSerie = document.getElementById("numeroSerie");
          var mac = document.getElementById("mac");
          numeroSerie.value = ""
          mac.value = ""
          numeroSerie.focus()
          this.setState({errorAdd: []})
          // this.setState({argsAdd: {}})
          this.props.allEquipo.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          // console.log(args)
          let argsUpd = {numeroSerie: args.numeroSerie, estadoEquipo: args.estadoEquipo,
            _idClaseEqu: args._idClaseEqu, codigoClaseEqu: args.codigoClaseEqu, descrClaseEqu: args.descrClaseEqu,
            _idMarcaEqu: args._idMarcaEqu, codigoMarcaEqu: args.codigoMarcaEqu, descrMarcaEqu: args.descrMarcaEqu,
            _idFabriEqu: args._idFabriEqu, codigoFabriEqu: args.codigoFabriEqu, descrFabriEqu: args.descrFabriEqu
          }
          if(args.estadoEquipo==="BODEGA"){
            argsUpd['tipoAct'] = "EditarEquipo"
            argsUpd['_idBodega'] = args._idBodega
            argsUpd['codigoBodega'] = args.codigoBodega
            argsUpd['descrBodega'] = args.descrBodega
          }
          if(args.estadoEquipo==="CLIENTE"){
            argsUpd['tipoAct'] = `EditarEquipo${args.contrato}`
          }

          // console.log(argsUpd)
          const response = await this.props.createEquipo({
            variables: argsUpd
          });
          const {errors, success} = response.data.createEquipo;
          if (!success){
            console.log(errors)
            this.setState({errorAdd: errors})
          }else{
            this.props.allEquipo.refetch()
            this.estadosFalse()
            this.setState({showEquipo: true})
          }
        }
        if(this.state.permiteDelete){
          let errors = []
          if(args.estadoEquipo==='CLIENTE'){
            errors.push({path: 'estadoEquipo', message: "El equipo se encuentra asignado a un cliente, NO LO PUEDE ELIMINAR"});
            this.setState({errorAdd: errors})
          }
          if(errors.length===0){
            const argsDel = {
              _id: args._id
            }
            await this.props.deleteEquipo({
              variables: argsDel
            });
            this.props.allEquipo.refetch()
            this.estadosFalse()
            this.setState({showEquipo: true})
          }
        }
      }
    }
  }

  handleClaseEqu = async (ev, args)=>{
    if((!args.codigoClaseEqu||!args.descrClaseEqu) && !this.state.permiteDelete){
      let sinCampo='XXX'
      this.validarHandle(args.codigoClaseEqu, 'codigoClaseEqu', '', 'Debe escribir el código',
                        args.descrClaseEqu, 'descrClaseEqu', '', 'Debe escribir la descripción',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '')
    }else{
      if(this.state.addClaseEqu){
        const response = await this.props.createClaseEqu({
          variables: args
        });
        const {errors, success} = response.data.createClaseEqu;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoClaseEqu = document.getElementById("codigoClaseEqu");
          var descrClaseEqu = document.getElementById("descrClaseEqu");
          codigoClaseEqu.value = ""
          descrClaseEqu.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allClaseEqu.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrClaseEqu: args.descrClaseEqu
          }
          const response = await this.props.editClaseEqu({
            variables: argsUpd
          });
          const {errors, success} = response.data.editClaseEqu;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allClaseEqu.refetch()
            this.estadosFalse()
            this.setState({showClaseEqu: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteClaseEqu({
            variables: argsDel
          });
          this.props.allClaseEqu.refetch()
          this.estadosFalse()
          this.setState({showClaseEqu: true})
        }
      }
    }
  }

  handleMarcaEqu = async (ev, args)=>{
    if((!args.codigoMarcaEqu||!args.descrMarcaEqu) && !this.state.permiteDelete){
      let sinCampo='XXX'
      this.validarHandle(args.codigoMarcaEqu, 'codigoMarcaEqu', '', 'Debe escribir el código',
                        args.descrMarcaEqu, 'descrMarcaEqu', '', 'Debe escribir la descripción',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '')
    }else{
      if(this.state.addMarcaEqu){
        const response = await this.props.createMarcaEqu({
          variables: args
        });
        const {errors, success} = response.data.createMarcaEqu;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoMarcaEqu = document.getElementById("codigoMarcaEqu");
          var descrMarcaEqu = document.getElementById("descrMarcaEqu");
          codigoMarcaEqu.value = ""
          descrMarcaEqu.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allMarcaEqu.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrMarcaEqu: args.descrMarcaEqu
          }
          const response = await this.props.editMarcaEqu({
            variables: argsUpd
          });
          const {errors, success} = response.data.editMarcaEqu;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allMarcaEqu.refetch()
            this.estadosFalse()
            this.setState({showMarcaEqu: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteMarcaEqu({
            variables: argsDel
          });
          this.props.allMarcaEqu.refetch()
          this.estadosFalse()
          this.setState({showMarcaEqu: true})
        }
      }
    }
  }

  handleFabriEqu = async (ev, args)=>{
    if((!args.codigoFabriEqu||!args.descrFabriEqu) && !this.state.permiteDelete){
      let sinCampo='XXX'
      this.validarHandle(args.codigoFabriEqu, 'codigoFabriEqu', '', 'Debe escribir el código',
                        args.descrFabriEqu, 'descrFabriEqu', '', 'Debe escribir la descripción',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '')
    }else{
      if(this.state.addFabriEqu){
        const response = await this.props.createFabriEqu({
          variables: args
        });
        const {errors, success} = response.data.createFabriEqu;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoFabriEqu = document.getElementById("codigoFabriEqu");
          var descrFabriEqu = document.getElementById("descrFabriEqu");
          codigoFabriEqu.value = ""
          descrFabriEqu.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allFabriEqu.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrFabriEqu: args.descrFabriEqu
          }
          const response = await this.props.editFabriEqu({
            variables: argsUpd
          });
          const {errors, success} = response.data.editFabriEqu;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allFabriEqu.refetch()
            this.estadosFalse()
            this.setState({showFabriEqu: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteFabriEqu({
            variables: argsDel
          });
          this.props.allFabriEqu.refetch()
          this.estadosFalse()
          this.setState({showFabriEqu: true})
        }
      }
    }
  }

  handleBodega = async (ev, args)=>{
    if((!args.codigoBodega||!args.descrBodega) && !this.state.permiteDelete){
      let sinCampo='XXX'
      this.validarHandle(args.codigoBodega, 'codigoBodega', '', 'Debe escribir el código',
                        args.descrBodega, 'descrBodega', '', 'Debe escribir la descripción',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '',
                        sinCampo, '', '', '')
    }else{
      if(this.state.addBodega){
        const response = await this.props.createBodega({
          variables: args
        });
        const {errors, success} = response.data.createBodega;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoBodega = document.getElementById("codigoBodega");
          var descrBodega = document.getElementById("descrBodega");
          codigoBodega.value = ""
          descrBodega.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allBodega.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrBodega: args.descrBodega
          }
          const response = await this.props.editBodega({
            variables: argsUpd
          });
          const {errors, success} = response.data.editBodega;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allBodega.refetch()
            this.estadosFalse()
            this.setState({showBodega: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteBodega({
            variables: argsDel
          });
          this.props.allBodega.refetch()
          this.estadosFalse()
          this.setState({showBodega: true})
        }
      }
    }
  }

  handleTipoos = async (ev, args)=>{
    args['permOfertas'] = "NO"
    // console.log(args.permOfertas)
    if(!args.codigoTipoOS||!args.descrTipoOS||
      !args.estadoAlCrear||args.estadoAlCrear==="Seleccionar..."||
      !args.permDireccion||args.permDireccion==="Seleccionar..."||
      !args.permTarServ||args.permTarServ==="Seleccionar..."||
      // !args.permOfertas||args.permOfertas==="Seleccionar..."||
      !args.permEquipos||args.permEquipos==="Seleccionar..."||!args.paraCliNuevo||args.paraCliNuevo==="Seleccionar..."||
      !args.pedirPtosAdic||args.pedirPtosAdic==="Seleccionar..."||
      !args.permImprimir||args.permImprimir==="Seleccionar..."||
      !args.estadoCrearOS||args.estadoCrearOS==="Seleccionar..."||!args.estadoCerrarOS||args.estadoCerrarOS==="Seleccionar..."||
      !args.generalCliente||args.generalCliente==="Seleccionar..."||!args.genOSDirAnt||args.genOSDirAnt==="Seleccionar..."||
      (args.genOSDirAnt==="SI"&&(!args.tipoOSDirAnt||args.tipoOSDirAnt==="Seleccionar..."))
    ){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoTipoOS){
        argsAdd['codigoTipoOS'] = "";
        errors.push({path: 'codigoTipoOS', message: "Debe escribir el código"});
      }
      if(!args.descrTipoOS){
        argsAdd['descrTipoOS'] = "";
        errors.push({path: 'descrTipoOS', message: "Debe escribir la descripción"});
      }
      if(!args.estadoAlCrear||args.estadoAlCrear==="Seleccionar..."){
        argsAdd['estadoAlCrear'] = "Seleccionar...";
        errors.push({path: 'estadoAlCrear', message: "Debe parametrizar el estado en que debe quedar la OS al crearla"});
      }
      if(!args.permDireccion||args.permDireccion==="Seleccionar..."){
        argsAdd['permDireccion'] = "Seleccionar...";
        errors.push({path: 'permDireccion', message: "Debe parametrizar que se permite con Direccion"});
      }
      if(!args.permTarServ||args.permTarServ==="Seleccionar..."){
        argsAdd['permTarServ'] = "Seleccionar...";
        errors.push({path: 'permTarServ', message: "Debe parametrizar que se permite con Tarifa/Servicios"});
      }
      if(!args.permOfertas||args.permOfertas==="Seleccionar..."){
        argsAdd['permOfertas'] = "Seleccionar...";
        errors.push({path: 'permOfertas', message: "Debe parametrizar que se permite con Ofertas"});
      }
      if(!args.permEquipos||args.permEquipos==="Seleccionar..."){
        argsAdd['permEquipos'] = "Seleccionar...";
        errors.push({path: 'permEquipos', message: "Debe parametrizar que se permite con Equipos"});
      }
      if(!args.paraCliNuevo||args.paraCliNuevo==="Seleccionar..."){
        argsAdd['paraCliNuevo'] = "Seleccionar...";
        errors.push({path: 'paraCliNuevo', message: "Debe parametrizar si el tipo de orden de servicio es para cliente nuevo"});
      }
      if(!args.pedirPtosAdic||args.pedirPtosAdic==="Seleccionar..."){
        argsAdd['pedirPtosAdic'] = "Seleccionar...";
        errors.push({path: 'pedirPtosAdic', message: "Debe parametrizar si el tipo de orden de servicio pide Puntos Adicionales"});
      }
      if(!args.permImprimir||args.permImprimir==="Seleccionar..."){
        argsAdd['permImprimir'] = "Seleccionar...";
        errors.push({path: 'permImprimir', message: "Debe parametrizar si el tipo de orden de servicio permite IMPRIMIR las OS"});
      }
      if(!args.estadoCrearOS||args.estadoCrearOS==="Seleccionar..."){
        argsAdd['estadoCrearOS'] = "Seleccionar...";
        errors.push({path: 'estadoCrearOS', message: "Debe parametrizar estado(s) del cliente al crear la OS"});
      }
      if(!args.estadoCerrarOS||args.estadoCerrarOS==="Seleccionar..."){
        argsAdd['estadoCerrarOS'] = "Seleccionar...";
        errors.push({path: 'estadoCerrarOS', message: "Debe parametrizar estado(s) del cliente al cerrar la OS"});
      }
      if(!args.generalCliente||args.generalCliente==="Seleccionar..."){
        argsAdd['generalCliente'] = "Seleccionar...";
        errors.push({path: 'generalCliente', message: "Debe parametrizar OS de tipo GENERAL / CLIENTE"});
      }
      if(!args.genOSDirAnt||args.genOSDirAnt==="Seleccionar..."){
        argsAdd['genOSDirAnt'] = "Seleccionar...";
        errors.push({path: 'genOSDirAnt', message: "Debe parametrizar Si cambia de dirección generar OS a dirección anterior"});
      }
      if(args.genOSDirAnt==="SI"&&(!args.tipoOSDirAnt||args.tipoOSDirAnt==="Seleccionar...")){
        argsAdd['tipoOSDirAnt'] = "Seleccionar...";
        errors.push({path: 'tipoOSDirAnt', message: "Debe parametrizar El tipo de OS a generar"});
      }

      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addTipoos){
        if(args.genOSDirAnt==="NO"){
          args['tipoOSDirAnt'] = ""
        }
        const response = await this.props.createTipoOS({
          variables: args
        });
        const {errors, success} = response.data.createTipoOS;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoTipoOS = document.getElementById("codigoTipoOS");
          var descrTipoOS = document.getElementById("descrTipoOS");
          var estadoAlCrear = document.getElementById("miListaEOS");
          estadoAlCrear.options.selectedIndex = 0
          var permDireccion = document.getElementById("miLista");
          permDireccion.options.selectedIndex = 0
          var permTarServ = document.getElementById("miLista1");
          permTarServ.options.selectedIndex = 0
          // var permOfertas = document.getElementById("miLista2");
          // permOfertas.options.selectedIndex = 0
          var permEquipos = document.getElementById("miLista3");
          permEquipos.options.selectedIndex = 0
          var paraCliNuevo = document.getElementById("miLista4");
          paraCliNuevo.options.selectedIndex = 0
          var pedirPtosAdic = document.getElementById("miListaPA");
          pedirPtosAdic.options.selectedIndex = 0
          var permImprimir = document.getElementById("miListaPI");
          permImprimir.options.selectedIndex = 0
          var estadoCrearOS = document.getElementById("miLista5");
          estadoCrearOS.options.selectedIndex = 0
          var estadoCerrarOS = document.getElementById("miLista6");
          estadoCerrarOS.options.selectedIndex = 0

          var generalCliente = document.getElementById("miListaETipo");
          generalCliente.options.selectedIndex = 0
          var genOSDirAnt = document.getElementById("miListaOSDA");
          genOSDirAnt.options.selectedIndex = 0
          var tipoOSDirAnt = document.getElementById("miListaTOS");
          if(tipoOSDirAnt){
            tipoOSDirAnt.options.selectedIndex = 0
          }

          codigoTipoOS.value = ""
          descrTipoOS.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allTiposOS.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            codigoTipoOS: args.codigoTipoOS,
            descrTipoOS: args.descrTipoOS,
            estadoAlCrear: args.estadoAlCrear,
            permDireccion: args.permDireccion,
            permTarServ: args.permTarServ,
            permOfertas: args.permOfertas,
            permEquipos: args.permEquipos,
            paraCliNuevo: args.paraCliNuevo,
            pedirPtosAdic: args.pedirPtosAdic,
            permImprimir: args.permImprimir,
            estadoCrearOS: args.estadoCrearOS,
            estadoCerrarOS: args.estadoCerrarOS,
            generalCliente: args.generalCliente,
            genOSDirAnt: args.genOSDirAnt,
            tipoOSDirAnt: args.genOSDirAnt==="NO"?"":args.tipoOSDirAnt
          }
          const response = await this.props.editTipoOS({
            variables: argsUpd
          });
          const {errors, success} = response.data.editTipoOS;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTiposOS.refetch()
            this.estadosFalse()
            this.setState({showTipoos: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id            
          }
          await this.props.deleteTipoOS({
            variables: argsDel
          });

          this.props.allTiposOS.refetch()
          this.estadosFalse()
          this.setState({showTipoos: true})
        }
      }
    }
  }

  handleClasifOST = async (ev, args)=>{
    // console.log(args)
    if(!args.descrClasifOST){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrClasifOST){
        argsAdd['descrClasifOST'] = "";
        errors.push({path: 'descrClasifOST', message: "Debe escribir la clasificación"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addClasifTipoos){
        const responseF = await this.props.fecha({
          variables: {}
        });
        const {fechaFechaHoy, fechaHoraHoy} = await responseF.data.fecha
        
        let argsAdd = args
        argsAdd['fechaCreate'] = fechaHoraHoy
        const response = await this.props.createClasifOST({
          variables: argsAdd
        });
        const {errors, success} = response.data.createClasifOST;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrClasifOST = document.getElementById("descrClasifOST");
          descrClasifOST.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allClasifOST.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrClasifOST: args.descrClasifOST
          }
          const response = await this.props.editClasifOST({
            variables: argsUpd
          });
          const {errors, success} = response.data.editClasifOST;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allClasifOST.refetch()
            this.estadosFalse()
            this.setState({showClasifTipoos: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteClasifOST({
            variables: argsDel
          });
          this.props.allClasifOST.refetch()
          this.estadosFalse()
          this.setState({showClasifTipoos: true})
        }
      }
    }
  }

  handleCategOST = async (ev, args)=>{
    // console.log(args)
    if(!args.descrCategOST){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrCategOST){
        argsAdd['descrCategOST'] = "";
        errors.push({path: 'descrCategOST', message: "Debe escribir la categoría"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addCategTipoos){
        const responseF = await this.props.fecha({
          variables: {}
        });
        const {fechaFechaHoy, fechaHoraHoy} = await responseF.data.fecha
        
        let argsAdd = args
        argsAdd['fechaCreate'] = fechaHoraHoy
        if(!argsAdd.observCategOST){
          argsAdd['observCategOST'] = ""
        }
        const response = await this.props.createCategOST({
          variables: argsAdd
        });
        const {errors, success} = response.data.createCategOST;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrCategOST = document.getElementById("descrCategOST");
          descrCategOST.value = ""
          var observCategOST = document.getElementById("observCategOST");
          observCategOST.value = ""
          let descrTipoOS = document.getElementById("miLista");
          descrTipoOS.options.selectedIndex = 0

          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allCategOST.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrCategOST: args.descrCategOST,
            observCategOST: args.observCategOST,
            codigoTipoOS: args.codigoTipoOS,
            descrTipoOS: args.descrTipoOS
          }
          const response = await this.props.editCategOST({
            variables: argsUpd
          });
          const {errors, success} = response.data.editCategOST;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allCategOST.refetch()
            this.estadosFalse()
            this.setState({showCategTipoos: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteCategOST({
            variables: argsDel
          });
          this.props.allCategOST.refetch()
          this.estadosFalse()
          this.setState({showCategTipoos: true})
        }
      }
    }
  }

  handleImpto = async (ev, args)=>{
    if((!args.codigoImpto||!args.descrImpto||!args.porcImpto||args.porcImpto===0) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoImpto){
        argsAdd['codigoImpto'] = "";
        errors.push({path: 'codigoImpto', message: "Debe escribir el código"});
      }
      if(!args.descrImpto){
        argsAdd['descrImpto'] = "";
        errors.push({path: 'descrImpto', message: "Debe escribir la descripción"});
      }
      if(!args.porcImpto||args.porcImpto===0){
        argsAdd['porcImpto'] = "";
        errors.push({path: 'porcImpto', message: "El porcentaje del impuesto debe ser mayor a cero"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addImpto){
        const response = await this.props.createImpto({
          variables: args
        });
        // console.log("paso")
        const {errors, success} = response.data.createImpto;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoImpto = document.getElementById("codigoImpto");
          var descrImpto = document.getElementById("descrImpto");
          var porcImpto = document.getElementById("porcImpto");
          codigoImpto.value = ""
          descrImpto.value = ""
          porcImpto.value = 0
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allImpto.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrImpto: args.descrImpto,
            porcImpto: args.porcImpto,
          }
          const response = await this.props.editImpto({
            variables: argsUpd
          });
          const {errors, success} = response.data.editImpto;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allImpto.refetch()
            this.estadosFalse()
            this.setState({showImpto: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteImpto({
            variables: argsDel
          });
          this.props.allImpto.refetch()
          this.estadosFalse()
          this.setState({showImpto: true})
        }
      }
    }
  }

  handleBD = async (ev, args)=>{
    if((!args.basededatos||!args.descrBaseDat) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.basededatos){
        argsAdd['basededatos'] = "";
        errors.push({path: 'basededatos', message: "Debe escribir la Base de Datos"});
      }
      if(!args.descrBaseDat){
        argsAdd['descrBaseDat'] = "";
        errors.push({path: 'descrBaseDat', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addBD){
        const response = await this.props.createBaseDat({
          variables: args
        });
        // console.log("paso")
        const {errors, success} = response.data.createBaseDat;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var basededatos = document.getElementById("basededatos");
          var descrBaseDat = document.getElementById("descrBaseDat");
          basededatos.value = ""
          descrBaseDat.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allBaseDat.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrBaseDat: args.descrBaseDat,
          }
          const response = await this.props.editBaseDat({
            variables: argsUpd
          });
          const {errors, success} = response.data.editBaseDat;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allBaseDat.refetch()
            this.estadosFalse()
            this.setState({showBD: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteBaseDat({
            variables: argsDel
          });
          this.props.allBaseDat.refetch()
          this.estadosFalse()
          this.setState({showBD: true})
        }
      }
    }
  }

  handleTarifa = async (ev, args)=>{
    if((!args.codigoTarifa||!args.descrTarifa||
      ((!args.cicloFact||args.cicloFact==="Seleccionar...")&&this.props.comoAsigCicloFact==="Asignarlo a una tarifa y automáticamente al cliente cuando se le asigne tarifa")) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoTarifa){
        argsAdd['codigoTarifa'] = "";
        errors.push({path: 'codigoTarifa', message: "Debe escribir el código"});
      }
      if(!args.descrTarifa){
        argsAdd['descrTarifa'] = "";
        errors.push({path: 'descrTarifa', message: "Debe escribir la descripción"});
      }
      if((!args.cicloFact||args.cicloFact==="Seleccionar...")&&this.props.comoAsigCicloFact==="Asignarlo a una tarifa y automáticamente al cliente cuando se le asigne tarifa"){
        argsAdd['cicloFact'] = "";
        errors.push({path: 'cicloFact', message: "Debe seleccionar elciclo de facturación"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addTarifa){
        if(this.props.allTarifa.allTarifa){
          let indexSearch = await this.props.allTarifa.allTarifa.findIndex( tarifa => tarifa.descrTarifa === args.descrTarifa );
          if(indexSearch!==-1){
            const errors = [];
            errors.push({path: 'descrTarifa', message: "La tarifa " + args.descrTarifa + " YA existe"});
            this.setState({errorAdd: errors})
          }else{
            const response = await this.props.createTarifa({
              variables: args
            });
            const {errors, success} = response.data.createTarifa;
            if (!success){
              this.setState({errorAdd: errors})
            }else{
              var codigoTarifa = document.getElementById("codigoTarifa");
              var descrTarifa = document.getElementById("descrTarifa");
              var cicloFact = document.getElementById("miListaCF");
              cicloFact.options.selectedIndex = 0
              // var estadoTarifa = document.getElementById("estadoTarifa");
              codigoTarifa.value = ""
              descrTarifa.value = ""
              // estadoTarifa.checked = true  //no funcona => ?
              this.setState({errorAdd: []})
              const argsAdd = {}
              argsAdd['estadoTarifa'] = args.estadoTarifa
              this.setState({argsAdd});
              this.props.allTarifa.refetch()
            }
          }
        }
      }else{
        if(this.state.permiteUpdate){
          let argsUpd = {}
          argsUpd = {
            _id: args._id,
            descrTarifa: args.descrTarifa,
            estadoTarifa: args.estadoTarifa,
            cicloFact: args.cicloFact,
          }
          const response = await this.props.editTarifa({
            variables: argsUpd
          });
          const {errors, success} = response.data.editTarifa;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTarifa.refetch()
            this.estadosFalse()
            this.setState({showTarifa: true})

            if(args.cicloFactAnt!==args.cicloFact){
              //ACTUALIZA cicloFact EN clientes
              let updDoc = [], updDocMany = [], updDocMany1 = []

              let updMatch1 = args.codigoTarifa
              let updSet1 = args.cicloFact
              let argsMatch = `'tarifa.codigoTarifa': '${updMatch1}'`
              let argsSet = `'cicloFact': '${updSet1}'`

              argsUpd = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Cliente.updateMany'}
              updDoc.push(argsUpd)

              updDoc.forEach((elementoDX, ii) => {
                updDocMany.push(elementoDX)
              })
              updDocMany1.push({docum: updDocMany})

              let numDocCRUD = 0, totDocCRUD = 1, argsCrud = [], crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.updDocumMany)
              }

              argsCrud[numDocCRUD] = updDocMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.updDocumMany

              await this.updColecc(crudColecc, argsCrud, totDocCRUD)
              //FIN ACTUALIZA cicloFact EN clientes
            }
            //ACTUALIZA EN clientes y odes
            let updDoc = [], updDocMany = [], updDocMany1 = []
            // console.log(args)
            let updMatch1 = args.codigoTarifa
            let updSet4 = args.descrTarifa
            let argsMatchCl1 = `'tarifa.codigoTarifa': '${updMatch1}'`
            let argsSetCl1 = `'tarifa.descrTarifa': '${updSet4}'`
            let argsUpdCl1 = {tipoqry: `{${argsMatchCl1}}, {$set: {${argsSetCl1}}}`, modelo: 'models.Cliente.updateMany'}
            // console.log(argsUpdCl)

            let argsMatchCl2 = `'tarifa.codigoTarifa': '${updMatch1}', estadoOS: 'ABIERTA'`
            let argsSetCl2 = `'tarifa.descrTarifa': '${updSet4}'`
            let argsUpdCl2 = {tipoqry: `{${argsMatchCl2}}, {$set: {${argsSetCl2}}}`, modelo: 'models.OdeS.updateMany'}

            // console.log(argsUpdCl)
            // console.log(argsUpdDM)
            updDoc.push(argsUpdCl1)
            updDoc.push(argsUpdCl2)

            // console.log(updDoc)

            updDoc.forEach((elemento, ii) => {
              // console.log(elemento)
              updDocMany.push(elemento)
              updDocMany1.push({docum: updDocMany})
              updDocMany = []
            })
            // updDocMany1.push({docum: updDocMany})

            let numDocCRUD = 0, totDocCRUD = 2, argsCrud = [], crudColecc = []
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.updDocumMany)
            }
            // console.log(updDocMany1[0])
            argsCrud[numDocCRUD] = updDocMany1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.updDocumMany
            // console.log(updDocMany1[1])
            numDocCRUD += 1
            argsCrud[numDocCRUD] = updDocMany1[1]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.updDocumMany

            // console.log(argsCrud)
            await this.updColecc(crudColecc, argsCrud, totDocCRUD)
            //FIN ACTUALIZA EN clientes y odes
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            "_id": args._id,
            "codigoTarifa": args.codigoTarifa
          }
          const response = await this.props.deleteTarifa({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteTarifa;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTarifa.refetch()
            this.estadosFalse()
            this.setState({showTarifa: true})
          }
        }
      }
    }
  }

  handleCSVEq = async (ev) => {
    let listaEq = []
    this.props.allEquipo.allEquipo.forEach((elemento, _id) => {
      if(elemento.codigoServicio!==null){
        let ubicacion = ""
        if(elemento.estadoEquipo==="CLIENTE"){
          ubicacion = elemento.contrato
        }else{
          ubicacion = elemento.bodega.descrBodega
        }
        listaEq.push({_id: elemento._id, numeroSerie: elemento.numeroSerie, mac: elemento.mac,
          estadoEquipo: elemento.estadoEquipo, ubicacion,
          descrClaseEqu: elemento.claseequ.descrClaseEqu, descrMarcaEqu: elemento.marcaequ.descrMarcaEqu,
          descrFabriEqu: elemento.fabriequ.descrFabriEqu
        })
      }
    })

    let nombreArch = "equipos.csv"

    let txtString = ""
    txtString += 'serial;mac;ubicadoEn;ubicacion;clase;marca;'
    txtString += 'fabricante'
    txtString += "\r\n";
    for(let i=0; i<listaEq.length; i++){
      txtString += listaEq[i].numeroSerie + ';'
      txtString += listaEq[i].mac + ';'
      txtString += listaEq[i].estadoEquipo + ';'
      txtString += listaEq[i].ubicacion + ';'
      txtString += listaEq[i].descrClaseEqu + ';'
      txtString += listaEq[i].descrMarcaEqu + ';'
      txtString += listaEq[i].descrFabriEqu
      txtString += "\r\n";
    }
    var blob = new Blob([txtString], {type: "text/plain;charset=utf-8"});
    saveAs(blob, nombreArch); 

    this.showEquipo(ev)

    alert(`Archivo generado con éxito`)
  }

  handleCSV = async (ev) => {
    let listaTar = []
    this.props.allTarifa.allTarifa.forEach((elemento, _id) => {
      if(elemento.servicios.length>0){
        elemento.servicios.forEach((elemento1, i) => {
          if(elemento1.codigoServicio!==null){
            let porcImpto = ""
            if(elemento1.imptos.length>0&&elemento1.imptos[0].porcImpto!==null){
              porcImpto = elemento1.imptos[0].porcImpto.toString()
            }
            listaTar.push({_id: elemento._id, codigoTarifa: elemento.codigoTarifa, descrTarifa: elemento.descrTarifa,
              codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido,
              descripcionServicio: elemento1.descripcionServicio, valor: elemento1.rango1Valor,
              porcImpto: porcImpto, estadoTarifa: elemento.estadoTarifa,
            })
          }
        })
      }
    })

    let nombreArch = "tarifas.csv"

    let txtString = ""
    txtString += 'codigoTarifa;descrTarifa;codigoServicio;nombreResumido;descripcionServicio;valor;'
    txtString += 'porcImpto;estadoTarifa'
    txtString += "\r\n";
    for(let i=0; i<listaTar.length; i++){
      txtString += listaTar[i].codigoTarifa + ';'
      txtString += listaTar[i].descrTarifa + ';'
      txtString += listaTar[i].codigoServicio + ';'
      txtString += listaTar[i].nombreResumido + ';'
      txtString += listaTar[i].descripcionServicio + ';'
      txtString += listaTar[i].valor + ';'
      txtString += listaTar[i].porcImpto + ';'
      txtString += listaTar[i].estadoTarifa
      txtString += "\r\n";
    }
    var blob = new Blob([txtString], {type: "text/plain;charset=utf-8"});
    saveAs(blob, nombreArch); 

    this.showTarifa(ev)

    alert(`Archivo generado con éxito`)
  }
  
  handleOferta = async (ev, args)=>{
    if((!args.codigoOferta||!args.descrOferta) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoOferta){
        argsAdd['codigoOferta'] = "";
        errors.push({path: 'codigoOferta', message: "Debe escribir el código"});
      }
      if(!args.descrOferta){
        argsAdd['descrOferta'] = "";
        errors.push({path: 'descrOferta', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addOferta){
        const response = await this.props.createOferta({
          variables: args
        });
        const {errors, success} = response.data.createOferta;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoOferta = document.getElementById("codigoOferta");
          var descrOferta = document.getElementById("descrOferta");
          // var estadoOferta = document.getElementById("estadoOferta");
          codigoOferta.value = ""
          descrOferta.value = ""
          // estadoOferta.checked = false   => NO funciona => ???
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allOferta.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrOferta: args.descrOferta,
            estadoOferta: args.estadoOferta,
          }
          const response = await this.props.editOferta({
            variables: argsUpd
          });
          const {errors, success} = response.data.editOferta;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allOferta.refetch()
            this.estadosFalse()
            this.setState({showOferta: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteOferta({
            variables: argsDel
          });
          this.props.allOferta.refetch()
          this.estadosFalse()
          this.setState({showOferta: true})
        }
      }
    }
  }

  handleTarifaServ = async (ev, args)=>{
    const errors = [];
    let totDocCRUD = 100

    // console.log(args)
    args.forEach((elemento, _id) => {
      let rango1I
      let rango2I
      let rango3I
      if(elemento.rango1NumServValorIni===null||elemento.rango1NumServValorIni===''){rango1I=null}else{rango1I=elemento.rango1NumServValorIni}
      if(elemento.rango2NumServValorIni===null||elemento.rango2NumServValorIni===''){rango2I=null}else{rango2I=elemento.rango2NumServValorIni}
      if(elemento.rango3NumServValorIni===null||elemento.rango3NumServValorIni===''){rango3I=null}else{rango3I=elemento.rango3NumServValorIni}
      let rango1F
      let rango2F
      let rango3F
      if(elemento.rango1NumServValorFin===null||elemento.rango1NumServValorFin===''){rango1F=null}else{rango1F=elemento.rango1NumServValorFin}
      if(elemento.rango2NumServValorFin===null||elemento.rango2NumServValorFin===''){rango2F=null}else{rango2F=elemento.rango2NumServValorFin}
      if(elemento.rango3NumServValorFin===null||elemento.rango3NumServValorFin===''){rango3F=null}else{rango3F=elemento.rango3NumServValorFin}
      let valor1
      let valor2
      let valor3
      if(elemento.rango1Valor===null||elemento.rango1Valor===''){valor1=null}else{valor1=elemento.rango1Valor}
      if(elemento.rango2Valor===null||elemento.rango2Valor===''){valor2=null}else{valor2=elemento.rango2Valor}
      if(elemento.rango3Valor===null||elemento.rango3Valor===''){valor3=null}else{valor3=elemento.rango3Valor}

      if(elemento.estadoServ===false){
        errors.push({path: 'servicios', message: `El servicio ${elemento.nombreResumido} esta seleccionado para quitar`});
      }
      if((rango1I===null&&rango1F===null)&&
        (rango2I===null&&rango2F===null)&&
        (rango3I===null&&rango3F===null)){
        errors.push({path: 'servicios', message: `En el servicio ${elemento.nombreResumido} el valor mínimo del Rango 1 debe ser mayor que cero`});
      }

      if((rango1I===null&&rango1F!==null)||
        (rango2I===null&&rango2F!==null)||
        (rango3I===null&&rango3F!==null)){
        errors.push({path: 'servicios', message: `El servicio ${elemento.nombreResumido} no tiene valores mínimos y si tiene valores máximos`});
      }else{
        if((rango1F===null&&rango1I!==null)||
          (rango2F===null&&rango2I!==null)||
          (rango3F===null&&rango3I!==null)){
          errors.push({path: 'servicios', message: `El servicio ${elemento.nombreResumido} tiene valores mínimos y no tiene valores máximos`});
        }else{
          if((rango1F!==null&&rango1I!==null)||
          (rango2F!==null&&rango2I!==null)||
          (rango3F!==null&&rango3I!==null)){
            if(Number(elemento.rango1NumServValorIni)<0||Number(elemento.rango1NumServValorFin)<0||Number(elemento.rango1Valor)<0||
              Number(elemento.rango2NumServValorIni)<0||Number(elemento.rango2NumServValorFin)<0||Number(elemento.rango2Valor)<0||
                Number(elemento.rango3NumServValorIni)<0||Number(elemento.rango3NumServValorFin)<0||Number(elemento.rango3Valor)<0){
              errors.push({path: 'servicios', message: `El servicio ${elemento.nombreResumido} tiene valores menores que cero`});
            }
            if(rango1I===0){
              errors.push({path: 'servicios', message: `En el servicio ${elemento.nombreResumido} el valor mínimo del Rango 1 no puede ser cero`});
            }
            if(Number(elemento.rango1NumServValorIni)>Number(elemento.rango1NumServValorFin)||
              Number(elemento.rango2NumServValorIni)>Number(elemento.rango2NumServValorFin)||
              Number(elemento.rango3NumServValorIni)>Number(elemento.rango3NumServValorFin)){
              errors.push({path: 'servicios', message: `El servicio ${elemento.nombreResumido}, tiene valores mínimos mayores a valores máximos`});
            }
            if((Number(elemento.rango1NumServValorFin)>=Number(elemento.rango2NumServValorIni)&&rango2I!==null)||
              (Number(elemento.rango2NumServValorFin)>=Number(elemento.rango3NumServValorIni)&&rango3I!==null)){
              errors.push({path: 'servicios', message: `El servicio ${elemento.nombreResumido} tiene valores mínimos menores o iguales a valores máximos de rangos previos`});
            }
            if((valor1===null&&rango1F!==null&&rango1I!==null)||
              (valor2===null&&rango2F!==null&&rango2I!==null)||
              (valor3===null&&rango3F!==null&&rango3I!==null)){
                errors.push({path: 'servicios', message: `El servicio ${elemento.nombreResumido} no tiene valores de tarifa para rangos asignados`});
            }
          }
        }
      }
    })
    if(errors.length>0){
      this.setState({errorAdd: errors})
    }
    // if(args.length===0){
    //   errors.push({path: 'servicios', message: "La tarifa no tiene servicios asignados"});

    //   this.setState({errorAdd: errors})
    // }else{
      if(errors.length===0){
        let arrayServTarIni=this.state.lisServTarIni
        const arrayServ = this.props.allServicios.allServicios
        let argsUpd, argsDel

        let actColecc = [], creaColecc = [], movColecc = []
        args.forEach((elemento, _id) => {
          let siExiste = false
          arrayServTarIni.forEach((elemento1, _id) => {
            if(elemento.codigoServicio===elemento1.codigoServicio){
              siExiste = true
            }
          })
          if(siExiste===false){
            arrayServ.forEach((elemento2, _id) => {
              if(elemento.codigoServicio===elemento2.codigoServicio){
                argsUpd = {
                  "tipoAct": "EditarTarSer",
                  "_id": this.state.idLista._id,
                  "codigoServicio" : elemento2.codigoServicio,
                  "nombreResumido" : elemento2.nombreResumido,
                  "descripcionServicio" : elemento2.descripcionServicio,
                  "_idSubclaseServ" : elemento2.subclaseserv._id,
                  "codigoSubclaseServ" : elemento2.subclaseserv.codigoSubclaseServ,
                  "descrSubclaseServ" : elemento2.subclaseserv.descrSubclaseServ,
                  "_idClaseServ" : elemento2.subclaseserv.claseserv._id,
                  "codigoClaseServ" : elemento2.subclaseserv.claseserv.codigoClaseServ,
                  "descrClaseServ" : elemento2.subclaseserv.claseserv.descrClaseServ
                };
                // console.log(argsUpd)
                creaColecc.push(argsUpd)
              }
            })
          }
        })

        arrayServTarIni.forEach((elemento, _id) => {
          let siExiste = false
          args.forEach((elemento1, _id) => {
            if(elemento.codigoServicio===elemento1.codigoServicio){
              siExiste = true
            }
          })
          if(siExiste===false){
            argsDel = {
              "tipoAct": "EliminarServicio",
              "_id": this.state.idLista._id,
              "codigoServicio": elemento.codigoServicio,
            };
            actColecc.push(argsDel)
          }
        })

        args.forEach((elemento, _id) => {
          // console.log(elemento)
          argsUpd = {
            "tipoAct": "EditarTarRangos",
            "_id": this.state.idLista._id,
            "codigoServicio": elemento.codigoServicio,
            "rango1NumServValorIni": elemento.rango1NumServValorIni,
            "rango1NumServValorFin": elemento.rango1NumServValorFin,
            "rango1Valor": elemento.rango1Valor,
            "rango2NumServValorIni": elemento.rango2NumServValorIni,
            "rango2NumServValorFin": elemento.rango2NumServValorFin,
            "rango2Valor": elemento.rango2Valor,
            "rango3NumServValorIni": elemento.rango3NumServValorIni,
            "rango3NumServValorFin": elemento.rango3NumServValorFin,
            "rango3Valor": elemento.rango3Valor,
            "velEfecDownstream": elemento.velEfecDownstream,
            "velEfecUpstream": elemento.velEfecUpstream,
            "codigoTipoTec": elemento.codigoTipoTec,
            "descrTipoTec": elemento.descrTipoTec,
            "colorServicio": elemento.colorServicio,
          }
          movColecc.push(argsUpd)
        })

        args.forEach((elemento, i) => {
          let numDocCRUD = 0
          totDocCRUD = movColecc.length + 1
          let argsCrud = [], crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editTarifaUpdServ)
          }
          let creaCol = creaColecc.filter(movim => movim.codigoServicio===elemento.codigoServicio)
            creaCol.forEach((elemento1, ii) => {
              argsCrud[numDocCRUD] = elemento1
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

            numDocCRUD += 1
          })

          let movCol = movColecc.filter(movim => movim.codigoServicio===elemento.codigoServicio)
          movCol.forEach((elemento1, ii) => {
            argsCrud[numDocCRUD] = elemento1
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

            numDocCRUD += 1
          })

          this.updColecc(crudColecc, argsCrud, totDocCRUD)
        })

        let numDocCRUD = 0
        totDocCRUD = actColecc.length
        let argsCrud = [], crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editTarifaUpdServ)
        }

        actColecc.forEach((elemento1, ii) => {
          argsCrud[numDocCRUD] = elemento1
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  
          numDocCRUD += 1
        })

        if(totDocCRUD>0){
          this.updColecc(crudColecc, argsCrud, totDocCRUD)
        }

        this.props.allTarifa.refetch()
        this.estadosFalse()
        this.setState({showTarifa: true})
        this.setState({stEntro: 0})
      }
    // }
  }

  handleTarifaServI = async (ev, args)=>{
    // console.log("handleTarifaServI")
    const errors = [];
    args.forEach((elemento, _id) => {
      if(elemento.estadoServ===false){
        errors.push({path: 'servicios', message: `El servicio ${elemento.nombreResumido} esta seleccionado para quitar`});
      }
    })
    if(errors.length>0){
      this.setState({errorAdd: errors})
    }
    if(errors.length===0){
      let arrayServTar=this.state.lisServTarIniI
      let actColecc = []

      args.forEach((elemento1, _id) => {
        if(elemento1.idImpto!==null){
          let arrayServ1 = arrayServTar.filter(item => item.codigoServicio===elemento1.codigoServicio);
          let idServImpto=-2
          arrayServ1.forEach((elemento, _id) => {
            if(elemento.idImpto===null){
              // let indexServ = arrayServTar.findIndex( servicio => servicio._id == elemento._id );
              idServImpto=elemento.codigoServicio
            }
            if(elemento1.idImpto===elemento.idImpto){
  //El impuesto ya esta asignado al servicio
              idServImpto=-1
            }
          })
          if(idServImpto!==-1){
  //impuesto no existe en el servicio
            const argsUpd = {
              "tipoAct": "CrearImpto",
              "_id": this.state.idLista._id,
              "codigoServicio": elemento1.codigoServicio,
              "_idImpto": elemento1.idImpto,
              "codigoImpto": elemento1.codigoImpto,
              "descrImpto": elemento1.descrImpto,
              "porcImpto": elemento1.porcImpto,
            }
            actColecc.push(argsUpd)
          }
        }
      })
      arrayServTar.forEach((elemento1, _id) => {
        let siExiste = false
        args.forEach((elemento, _id) => {
          if(elemento1.codigoServicio===elemento.codigoServicio && elemento1.idImpto===elemento.idImpto){
            siExiste = true
          }
        })
        if(siExiste === false){
//se quitó el impuesto => eliminarlo          
          const argsDel = {
            "tipoAct": "EliminarImpto",
            "_id": this.state.idLista._id,
            "codigoServicio": elemento1.codigoServicio,
            "_idImpto": elemento1.idImpto,
          }
          actColecc.push(argsDel)
        }
      })

      let numDocCRUD = 0
      let totDocCRUD = actColecc.length
      let argsCrud = [], crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editTarifaUpdServ)
      }

      actColecc.forEach((elemento1, ii) => {
        argsCrud[numDocCRUD] = elemento1
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

        numDocCRUD += 1
      })

      if(totDocCRUD>0){
        this.updColecc(crudColecc, argsCrud, totDocCRUD)
      }

      this.props.allTarifa.refetch()
      this.estadosFalse()
      this.setState({showTarifa: true})
      this.setState({stEntro: 0})
    }
  }

  actOferServ = async (argsUpd)=>{
    const response = await this.props.editOfertaUpdServ({
      variables: argsUpd
    });
    const {errors, success} = response.data.editOfertaUpdServ;
    if (!success){
      this.setState({errorAdd: errors})
    }
  }

  handleOfertaServ = async (ev, args)=>{
    const errors = [];

    let totDocCRUD = 100

    args.forEach((elemento, _id) => {
      if(elemento.estadoServ===false){
        errors.push({path: 'servicios', message: `El servicio ${elemento.descripcionServicio} esta seleccionado para quitar`});
      }
      let porc
      let dias
      if(elemento.porcDctoOferta===null||elemento.porcDctoOferta===''){porc=null}else{porc=elemento.porcDctoOferta}
      if(elemento.numDiasOferta===null||elemento.numDiasOferta===''){dias=null}else{dias = elemento.numDiasOferta}

      if(porc===null){
        errors.push({path: 'servicios', message: `El servicio ${elemento.descripcionServicio} no tiene el % de descuento`});
      }
      if(dias===null){
        errors.push({path: 'servicios', message: `El servicio ${elemento.descripcionServicio} no tiene el número de días`});
      }

      if(porc<0||porc>100){
          errors.push({path: 'servicios', message: `En el servicio ${elemento.descripcionServicio} el % de descuento debe ser mayor que cero y máximo 100`});
      }
      if(dias<0){
        errors.push({path: 'servicios', message: `El servicio ${elemento.descripcionServicio} tiene número de días menor que cero`});
    }
    })
    if(errors.length>0){
      this.setState({errorAdd: errors})
    }
      if(errors.length===0){
        let arrayServTarIni=this.state.lisServTarIni
        const arrayServ = this.props.allServicios.allServicios
        let argsUpd, argsDel
        
        let actColecc = [], creaColecc = [], movColecc = []

        args.forEach((elemento, _id) => {
          let siExiste = false
          arrayServTarIni.forEach((elemento1, _id) => {
            if(elemento.codigoServicio===elemento1.codigoServicio){
              siExiste = true
            }
          })
          if(siExiste===false){
            arrayServ.forEach((elemento2, _id) => {
              if(elemento.codigoServicio===elemento2.codigoServicio){
                argsUpd = {
                  "tipoAct": "EditarOferSer",
                  "_id": this.state.idLista._id,
                  "codigoServicio" : elemento2.codigoServicio,
                  "nombreResumido" : elemento2.nombreResumido,
                  "descripcionServicio" : elemento2.descripcionServicio,
                  "_idSubclaseServ" : elemento2.subclaseserv._id,
                  "codigoSubclaseServ" : elemento2.subclaseserv.codigoSubclaseServ,
                  "descrSubclaseServ" : elemento2.subclaseserv.descrSubclaseServ,
                  "_idClaseServ" : elemento2.subclaseserv.claseserv._id,
                  "codigoClaseServ" : elemento2.subclaseserv.claseserv.codigoClaseServ,
                  "descrClaseServ" : elemento2.subclaseserv.claseserv.descrClaseServ
                };
                creaColecc.push(argsUpd)
                // this.actOferServ(argsUpd)
                //editOfertaUpdServ
              }
            })
          }
        })

        arrayServTarIni.forEach((elemento, _id) => {
          let siExiste = false
          args.forEach((elemento1, _id) => {
            if(elemento.codigoServicio===elemento1.codigoServicio){
              siExiste = true
            }
          })
          if(siExiste===false){
            argsDel = {
              "tipoAct": "EliminarServicio",
              "_id": this.state.idLista._id,
              "codigoServicio": elemento.codigoServicio,
            };
            actColecc.push(argsDel)
            // this.actOferServ(argsDel)
            //editOfertaUpdServ
          }
        })

        args.forEach((elemento, _id) => {
          argsUpd = {
            "tipoAct": "EditarOferPorc",
            "_id": this.state.idLista._id,
            "codigoServicio": elemento.codigoServicio,
            "porcDctoOferta": elemento.porcDctoOferta,
            "numDiasOferta": elemento.numDiasOferta,
          }
          movColecc.push(argsUpd)
          // this.actOferServ(argsUpd)
          //editOfertaUpdServ
        })

        args.forEach((elemento, i) => {
          let numDocCRUD = 0
          let totDocCRUD = movColecc.length + 1
          let argsCrud = [], crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editOfertaUpdServ)
          }
          let creaCol = creaColecc.filter(movim => movim.codigoServicio===elemento.codigoServicio)
            creaCol.forEach((elemento1, ii) => {
              argsCrud[numDocCRUD] = elemento1
              argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

            numDocCRUD += 1
          })

          let movCol = movColecc.filter(movim => movim.codigoServicio===elemento.codigoServicio)
          movCol.forEach((elemento1, ii) => {
            argsCrud[numDocCRUD] = elemento1
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

            numDocCRUD += 1
          })

          this.updColecc(crudColecc, argsCrud, totDocCRUD)
        })

        let numDocCRUD = 0
        totDocCRUD = actColecc.length
        let argsCrud = [], crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editOfertaUpdServ)
        }

        actColecc.forEach((elemento1, ii) => {
          argsCrud[numDocCRUD] = elemento1
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  
          numDocCRUD += 1
        })

        if(totDocCRUD>0){
          this.updColecc(crudColecc, argsCrud, totDocCRUD)
        }

        this.props.allOferta.refetch()
        this.estadosFalse()
        this.setState({showOferta: true})
        this.setState({stEntro: 0})
      }
    // }
  }

  handleListaTipo = () => {
    let miLista = document.getElementById("miListaETipo");
    const argsAdd = this.state.argsAdd
    argsAdd['generalCliente'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleListaOSDA = () => {
    let miLista = document.getElementById("miListaOSDA");
    const argsAdd = this.state.argsAdd
    argsAdd['genOSDirAnt'] = miLista.options[miLista.selectedIndex].text
    // console.log(miLista.options[miLista.selectedIndex].text)
    if(miLista.options[miLista.selectedIndex].text==="NO"||miLista.options[miLista.selectedIndex].text==="Seleccionar..."){
      argsAdd['tipoOSDirAnt'] = "Seleccionar..."
    }
    this.setState({argsAdd});
  }

  handleListaTOS = () => {
    let miLista = document.getElementById("miListaTOS");
    const argsAdd = this.state.argsAdd
    argsAdd['tipoOSDirAnt'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handlePermEOS = () => {
    let miLista = document.getElementById("miListaEOS");
    const argsAdd = this.state.argsAdd
    argsAdd['estadoAlCrear'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handlePermDirOS = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['permDireccion'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handlePermTarSerOS = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['permTarServ'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handlePermOfeOS = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['permOfertas'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handlePermEquOS = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['permEquipos'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleParaClNuOS = () => {
    var miLista = document.getElementById("miLista4");
    const argsAdd = this.state.argsAdd
    argsAdd['paraCliNuevo'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handlePedirPtosAdic = () => {
    var miLista = document.getElementById("miListaPA");
    const argsAdd = this.state.argsAdd
    argsAdd['pedirPtosAdic'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handlePermImprimir = () => {
    var miLista = document.getElementById("miListaPI");
    const argsAdd = this.state.argsAdd
    argsAdd['permImprimir'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleEstCrearOS = () => {
    var miLista = document.getElementById("miLista5");
    const argsAdd = this.state.argsAdd
    argsAdd['estadoCrearOS'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleEstCerrarOS = () => {
    var miLista = document.getElementById("miLista6");
    const argsAdd = this.state.argsAdd
    argsAdd['estadoCerrarOS'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleparaProcMasDX = () => {
    var miLista = document.getElementById("miLista7");
    const argsAdd = this.state.argsAdd
    argsAdd['paraProcMasDX'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleTipoRecRec = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['descrTipoRec'] = miLista.options[miLista.selectedIndex].text
    argsAdd['_idTipoRec'] = miLista.options[miLista.selectedIndex].value
    argsAdd['areaAprovech'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  }

  handleCiudadDpto = () => {
    // console.log("55")
    this.setState({argsAdd: {}})
    let miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['descrDpto'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text!=="Todos..."){
      argsAdd['codigoDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['_idDpto'] = miLista.options[miLista.selectedIndex].value
    }else{
      argsAdd['descrDpto'] = "Todos..."
      argsAdd['codigoDpto'] = "Todos..."
      argsAdd['_idDpto'] = "Todos..."
    }
    argsAdd['codigoCiudad'] = "Todas..."
    argsAdd['nombreCiudad'] = "Todas..."           
    argsAdd['codigoCiudadInterno'] = ""
    argsAdd['codBarrasRdo'] = ""

    this.setState({argsAdd});
  }

  handleZonaCiudad = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreCiudad'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text==="Todas..."){
      argsAdd['codigoCiudad'] = "Todas..."
      argsAdd['codigoCiudadInterno'] = ""
      argsAdd['codBarrasRdo'] = ""
    }else{
      argsAdd['codigoCiudad'] = miLista.options[miLista.selectedIndex].value
      argsAdd['codigoCiudadInterno'] = miLista.options[miLista.selectedIndex].attributes[1].value
      argsAdd['codBarrasRdo'] = miLista.options[miLista.selectedIndex].attributes[2].value
    }
    this.setState({argsAdd});
  }

  handleClaseEquEqu = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['_idClaseEqu'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoClaseEqu'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['descrClaseEqu'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      argsAdd['descrClaseEqu'] = "Seleccionar..."
    }
    this.setState({argsAdd});
  }

  handleMarcaEquEqu = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['_idMarcaEqu'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoMarcaEqu'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['descrMarcaEqu'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      argsAdd['descrMarcaEqu'] = "Seleccionar..."
    }
    this.setState({argsAdd});
  }

  handleFabriEquEqu = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['_idFabriEqu'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoFabriEqu'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['descrFabriEqu'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      argsAdd['descrFabriEqu'] = "Seleccionar..."
    }
    this.setState({argsAdd});
    // console.log(argsAdd)
  }

  handleBodegaEqu = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['_idBodega'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsAdd['codigoBodega'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['descrBodega'] = miLista.options[miLista.selectedIndex].attributes[1].value
      argsAdd['estadoEquipo'] = "BODEGA"
    }else{
      argsAdd['descrBodega'] = "Seleccionar..."
    }
    this.setState({argsAdd});
  }

  handleTipoDocRec = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['codigoTipoDoc'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleTipoOSCateg = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['descrTipoOS'] = miLista.options[miLista.selectedIndex].text
    argsAdd['codigoTipoOS'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  }

  handleAreaaprovechTR = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['areaAprovech'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleClaseSub = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['descrClaseServ'] = miLista.options[miLista.selectedIndex].text
    argsAdd['_idClaseserv'] = miLista.options[miLista.selectedIndex].value
    argsAdd['codigoClaseServ'] = miLista.options[miLista.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  }

  handleSubclaseSer = () => {
    var miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['_idSubclaseServ'] = miLista.options[miLista.selectedIndex].value
    argsAdd['_idClaseServ'] = miLista.options[miLista.selectedIndex].attributes[0].value
// console.log(miLista.options[miLista.selectedIndex].text)
    let posic1 = miLista.options[miLista.selectedIndex].text.indexOf(":")
    // console.log(posic1)
    argsAdd['codigoClaseServ'] = miLista.options[miLista.selectedIndex].text.substr(0, posic1)

    let posic2 = miLista.options[miLista.selectedIndex].text.indexOf("=")
    argsAdd['descrClaseServ'] = miLista.options[miLista.selectedIndex].text.substr(posic1 + 2, posic2 - 6)

    posic1 = miLista.options[miLista.selectedIndex].text.indexOf(":", posic2)
    argsAdd['codigoSubclaseServ'] = miLista.options[miLista.selectedIndex].text.substr(posic2 + 3, posic1 - posic2 - 3)

    argsAdd['descrSubclaseServ'] = miLista.options[miLista.selectedIndex].text.substr(posic1 + 2)

    this.setState({argsAdd});
  }

  handleListaTipoTec = () => {
    var miLista = document.getElementById("miListaTT");
    const argsAdd = this.state.argsAdd
    argsAdd['codigoTipoTec'] = miLista.options[miLista.selectedIndex].value
    argsAdd['descrTipoTec'] = miLista.options[miLista.selectedIndex].attributes[0].value

    this.setState({argsAdd});
  }

  handleCicloFactCl = () => {
    var miLista = document.getElementById("miListaCF");
    const argsAdd = this.state.argsAdd
    argsAdd['cicloFact'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  idLista = async (ev, idLista)=>{
    // console.log(idLista)
    this.setState({idLista: idLista})
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showServicio) {
      this.setState({verServicio: true})
    }
    if (this.state.showClase) {
      this.setState({verClase: true})
    }
    if (this.state.showSubclase) {
      this.setState({verSubclase: true})
    }
    if (this.state.showTiTe) {
      this.setState({verTiTe: true})
    }
    if (this.state.showTiporec) {
      this.setState({verTiporec: true})
    }
    if (this.state.showRecurso) {
      this.setState({verRecurso: true})
    }
    if (this.state.showTipoos) {
      this.setState({verTipoos: true})
    }
    if (this.state.showClasifTipoos) {
      this.setState({verClasifTipoos: true})
    }
    if (this.state.showCategTipoos) {
      this.setState({verCategTipoos: true})
    }
    if (this.state.showImpto) {
      this.setState({verImpto: true})
    }
    if (this.state.showBD) {
      this.setState({verBD: true})
    }
    if (this.state.showTarifa) {
      this.setState({verTarifa: true})
    }
    if (this.state.showOferta) {
      this.setState({verOferta: true})
    }
    if (this.state.showEquipo) {
      this.setState({verEquipo: true})
    }
    if (this.state.showClaseEqu) {this.setState({verClaseEqu: true})}
    if (this.state.showMarcaEqu) {this.setState({verMarcaEqu: true})}
    if (this.state.showFabriEqu) {
      this.setState({verFabriEqu: true})
    }
    if (this.state.showBodega) {
      this.setState({verBodega: true})
    }
  };

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: true, permiteDelete: false})
  }

  handleClickDel = async (ev) => {
    ev.preventDefault()
    this.setState({
      permiteUpdate: false,
      permiteDelete: true,
    })
  }

  componentDidUpdate(prevProps){
    if(this.props.allTarifa.allTarifa&&this.props.allOferta.allOferta){
      // console.log(this.state.stEntro)
      if((this.props.allTarifa.allTarifa!==prevProps.allTarifa.allTarifa||
        this.props.allOferta.allOferta!==prevProps.allOferta.allOferta)&&this.state.stEntro<2){
        // console.log(this.props.allTarifa.allTarifa.length, this.props.allOferta.allOferta.length)
        this.setState({stEntro: this.state.stEntro + 1})
        this.props.allTarifa.refetch()
        this.props.allOferta.refetch()
      }
    }
  }

  render(){
    const {showConf, showServicio, addServicio, verServicio,
      showClase, addClase, verClase,
      showSubclase, addSubclase, verSubclase,
      showTiTe, addTiTe, verTiTe,
      showEquipo, addEquipo, verEquipo,
      showClaseEqu, addClaseEqu, verClaseEqu,
      showMarcaEqu, addMarcaEqu, verMarcaEqu,
      showFabriEqu, addFabriEqu, verFabriEqu,
      showBodega, addBodega, verBodega,
      showTipoos, addTipoos, verTipoos,
      showClasifTipoos, addClasifTipoos, verClasifTipoos,
      showCategTipoos, addCategTipoos, verCategTipoos,
      showImpto, addImpto, verImpto,
      showTarifa, addTarifa, verTarifa,
      showSerTar, showSerTarI,
      showOferta, addOferta, verOferta, showSerOfer,
      showTiporec, addTiporec, verTiporec,
      showRecurso, addRecurso, verRecurso,
      showParametro,
      showBD, addBD, verBD,
      permiteUpdate, permiteDelete, argsAdd, errorAdd, idLista,
      lisServTar, lisServ, lisServTarIni, lisServIni, lisServTarI, lisServTarIniI} = this.state;        

      // console.log(this.state) 
    // console.log(lisServ)
    // console.log(stEntro)
    let lista = []
    let lista1 = []
    let lista2 = []
    let lista3 = []

    if (this.state.showServicio) {
      if(this.props.allServicios.allServicios){lista = this.props.allServicios.allServicios}
    }
    if (this.state.showClase) {
      if(this.props.allClasesServ.allClasesServ){lista = this.props.allClasesServ.allClasesServ}
    }
    if (this.state.showSubclase) {
      if(this.props.allSubclasesServ.allSubclasesServ){lista = this.props.allSubclasesServ.allSubclasesServ}
    }
    if (this.state.showTiTe) {
      if(this.props.allTipoTec.allTipoTec){lista = this.props.allTipoTec.allTipoTec}
    }
    if (this.state.showTiporec) {
      if(this.props.allTipoRec.allTipoRec){lista = this.props.allTipoRec.allTipoRec}
    }
    if (this.state.showRecurso) {
      if(this.props.allRecurso.allRecurso){
        lista = this.props.allRecurso.allRecurso
        if(this.props.codigoDptoUA!=="Todos..."){
          lista = lista.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA||elemento.codigoDpto==="Todos...")
        }
        if(this.props.codigoCiudadUA!=="Todas..."){
          lista = lista.filter(elemento => elemento.codigoCiudad===this.props.codigoCiudadUA||elemento.codigoCiudad==="Todas...")
        }
      }
    }
    // console.log(this.props.getParametro.getParametro)
    // console.log(this.state.showParametro)
    if (this.state.showParametro) {
      if(this.props.getParametro.getParametro){lista = this.props.getParametro.getParametro}
    }
    // console.log(lista)
    if (this.state.addRecurso || this.state.verRecurso) {
      if(!argsAdd.codigoCiudad&&this.props.codigoCiudadUA==="Todas..."){
        argsAdd['_idDpto'] = "Todos..."
        argsAdd['codigoDpto'] = "Todos..."
        argsAdd['descrDpto'] = "Todos..."
        argsAdd['codigoCiudad'] = "Todas..."
        argsAdd['nombreCiudad'] = "Todas..."           
      }
      if(this.props.allDirmayor.allDirmayor&&this.props.codigoDptoUA!=="Todos..."){
        let listaDir = this.props.allDirmayor.allDirmayor
        listaDir = listaDir.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA)
        argsAdd['codigoDpto'] = listaDir[0].codigoDpto
        argsAdd['descrDpto'] = listaDir[0].descrDpto
        argsAdd['_idDpto'] = listaDir[0]._id
      }

      if(this.props.allDirmayor.allDirmayor){
        lista1 = this.props.allDirmayor.allDirmayor
        if(this.props.codigoCiudadUA!=="Todas..."){
          let listaD = []
          lista1.forEach((elemento, _id) => {
            if(listaD.length===0){
              elemento.ciudades.forEach((elemento1, _id) => {
                if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                  listaD.push(elemento)
                }
              })
            }
          })
          lista1 = listaD
        }
        // console.log(lista1)
      }

      if(this.props.allTipoRec.allTipoRec){lista = this.props.allTipoRec.allTipoRec}
      if(this.props.allTiposDoc.allTiposDoc){lista2 = this.props.allTiposDoc.allTiposDoc}
    }
    if (this.state.showEquipo) {
      if(this.props.allEquipo.allEquipo){lista = this.props.allEquipo.allEquipo}
    }
    if (this.state.addEquipo || this.state.verEquipo) {
      if(this.props.allMarcaEqu.allMarcaEqu){lista1 = this.props.allMarcaEqu.allMarcaEqu}
      if(this.props.allFabriEqu.allFabriEqu){lista2 = this.props.allFabriEqu.allFabriEqu}
      if(this.props.allBodega.allBodega){lista3 = this.props.allBodega.allBodega}
    }
    if (this.state.showClaseEqu || this.state.addEquipo || this.state.verEquipo) {
      if(this.props.allClaseEqu.allClaseEqu){lista = this.props.allClaseEqu.allClaseEqu}
    }
    if (this.state.showMarcaEqu) {
      if(this.props.allMarcaEqu.allMarcaEqu){lista = this.props.allMarcaEqu.allMarcaEqu}
    }
    if (this.state.showFabriEqu) {
      if(this.props.allFabriEqu.allFabriEqu){lista = this.props.allFabriEqu.allFabriEqu}
    }
    if (this.state.showBodega) {
      if(this.props.allBodega.allBodega){lista = this.props.allBodega.allBodega}
    }
    if (this.state.showTipoos||this.state.addTipoos||this.state.verTipoos) {
      if(this.props.allTiposOS.allTiposOS){lista = this.props.allTiposOS.allTiposOS}
    }
    if (this.state.showClasifTipoos) {
      if(this.props.allClasifOST.allClasifOST){lista = this.props.allClasifOST.allClasifOST}
    }
    if (this.state.showCategTipoos) {
      if(this.props.allCategOST.allCategOST){lista = this.props.allCategOST.allCategOST}
      lista = _.orderBy(lista, ['descrTipoOS', 'descrCategOST'])
    }
    if (this.state.addCategTipoos || this.state.verCategTipoos) {
      if(this.props.allTiposOS.allTiposOS){lista = this.props.allTiposOS.allTiposOS}
    }
    if (this.state.showImpto || this.state.showSerTarI || this.state.showOSTarI) {
      if(this.props.allImpto.allImpto){lista = this.props.allImpto.allImpto}
    }
    if (this.state.showTarifa) {
      if(this.props.allTarifa.allTarifa){lista = this.props.allTarifa.allTarifa}
    }
    let a25100505 = -1
    if (this.state.verTarifa) {
      a25100505 = this.props.autorizacUA.findIndex( autorizac => autorizac === "25100505" );
    }
    if (this.state.showOferta) {
      if(this.props.allOferta.allOferta){lista = this.props.allOferta.allOferta}
    }
    if (this.state.showBD) {
      if(this.props.allBaseDat.allBaseDat){lista = this.props.allBaseDat.allBaseDat}
    }

// console.log(idLista)
// console.log(this.props.allTarifa.allTarifa)
// console.log(this.props.allOferta.allOferta)

// console.log(lisServTar)
// console.log(lisServ)
// console.log(lisServIni)
// console.log(lisServTarIni)
    return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showConf && <HomeConf1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickSel1={this.showServicio}
                          handleClickSel2={this.showImpto} handleClickSel3={this.showTarifa}
                          handleClickSel4={this.showOferta} handleClickSel5={this.showTipoos}
                          handleClickSelCl={this.showClasifTipoos}
                          handleClickSelCa={this.showCategTipoos}
                          handleClickSel6={this.showEquipo} handleClickSel7={this.showTiporec}
                          handleClickSel8={this.showRecurso} handleClickSel9={this.showParametro}
                          handleClickSel10={this.showBD}/>}

            {showServicio && <ConfServ1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickSubcl={this.showSubclase} handleClickCl={this.showClase} handleClickTT={this.showTiTe} handleClickRegr={this.showConf}/>}
            {addServicio && <AddServicio1 styles={this.props.styles} handleClickRegr={this.showServicio}/>}
            {verServicio && <VerSer1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showServicio} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showClase && <ConfClase1 styles={this.props.styles} handleClickRegr={this.showServicio}/>}
            {addClase && <AddClase1 styles={this.props.styles} handleClickRegr={this.showClase}/>}
            {verClase && <VerCla1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showClase} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showSubclase && <ConfSubclase1 styles={this.props.styles} handleClickRegr={this.showServicio}/>}
            {addSubclase && <AddSubclase1 styles={this.props.styles} handleClickRegr={this.showSubclase}/>}
            {verSubclase && <VerScl1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showSubclase} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showTiTe && <ConfTiTe1 styles={this.props.styles} handleClickRegr={this.showServicio}/>}
            {addTiTe && <AddTiTe1 styles={this.props.styles} handleClickRegr={this.showTiTe}/>}
            {verTiTe && <VerTiTe1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showTiTe} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showImpto && <ConfImpto1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addImpto && <AddImpto1 styles={this.props.styles} handleClickRegr={this.showImpto}/>}
            {verImpto && <VerImpto1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showImpto} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showTarifa && <ConfTar1 styles={this.props.styles} handleClickRegr={this.showConf} handleCSV={this.handleCSV}/>}
            {addTarifa && <AddTar1 styles={this.props.styles} handleClickRegr={this.showTarifa}/>}
            {verTarifa && <VerTar1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showTarifa} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel} handleClickSel1={this.showSerTar}/>}

            {showSerTar && <ConfSerT1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.verTarifa} handleClickSel1={this.showSerTarI}/>}
            {showSerTarI && <ConfSerTI1 styles={this.props.styles} handleClickRegr={this.showSerTar}/>}

            {showOferta && <ConfOfer1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addOferta && <AddOfer1 styles={this.props.styles} handleClickRegr={this.showOferta}/>}
            {verOferta && <VerOfer1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showOferta} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel} handleClickSel1={this.showSerOfer}/>}

            {showSerOfer && <ConfSerO1 styles={this.props.styles} handleClickRegr={this.verOferta}/>}

            {showTiporec && <ConfTire1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addTiporec && <AddTire1 styles={this.props.styles} handleClickRegr={this.showTiporec}/>}
            {verTiporec && <VerTire1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showTiporec} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showRecurso && <ConfRec1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addRecurso && <AddRec1 styles={this.props.styles} handleClickRegr={this.showRecurso}/>}
            {verRecurso && <VerRec1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showRecurso} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showParametro && <VerParam1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showConf} handleClickUpd={this.handleClickUpd}/>}

            {showBD && <ConfBD1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addBD && <AddBD1 styles={this.props.styles} handleClickRegr={this.showBD}/>}
            {verBD && <VerBD1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showBD} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showEquipo && <ConfEqu1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                handleCSV={this.handleCSVEq}
                handleClickRegr={this.showConf} handleClickSel1={this.showClaseEqu}
                handleClickSel2={this.showMarcaEqu} handleClickSel3={this.showFabriEqu}
                handleClickSel4={this.showBodega}/>}
            {addEquipo && <AddEqu1 styles={this.props.styles} handleClickRegr={this.showEquipo}/>}
            {verEquipo && <VerEqu1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showEquipo} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showClaseEqu && <ConfClaseEqu1 styles={this.props.styles} handleClickRegr={this.showEquipo}/>}
            {addClaseEqu && <AddClaseEqu1 styles={this.props.styles} handleClickRegr={this.showClaseEqu}/>}
            {verClaseEqu && <VerClaseEqu1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showClaseEqu} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showMarcaEqu && <ConfMarcaEqu1 styles={this.props.styles} handleClickRegr={this.showEquipo}/>}
            {addMarcaEqu && <AddMarcaEqu1 styles={this.props.styles} handleClickRegr={this.showMarcaEqu}/>}
            {verMarcaEqu && <VerMarcaEqu1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showMarcaEqu} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showFabriEqu && <ConfFabriEqu1 styles={this.props.styles} handleClickRegr={this.showEquipo}/>}
            {addFabriEqu && <AddFabriEqu1 styles={this.props.styles} handleClickRegr={this.showFabriEqu}/>}
            {verFabriEqu && <VerFabriEqu1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showFabriEqu} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showBodega && <ConfBodega1 styles={this.props.styles} handleClickRegr={this.showEquipo}/>}
            {addBodega && <AddBodega1 styles={this.props.styles} handleClickRegr={this.showBodega}/>}
            {verBodega && <VerBodega1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showBodega} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showTipoos && <ConfTios1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addTipoos && <AddTios1 styles={this.props.styles} handleClickRegr={this.showTipoos}/>}
            {verTipoos && <VerTios1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showTipoos} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showClasifTipoos && <ConfClOST1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addClasifTipoos && <AddClOST1 styles={this.props.styles} handleClickRegr={this.showClasifTipoos}/>}
            {verClasifTipoos && <VerClOST1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showClasifTipoos} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showCategTipoos && <ConfCaOST1 styles={this.props.styles} handleClickRegr={this.showConf}/>}
            {addCategTipoos && <AddCaOST1 styles={this.props.styles} handleClickRegr={this.showCategTipoos}/>}
            {verCategTipoos && <VerCaOST1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showCategTipoos} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}
          </div>
          <div className="column" style={this.props.styles.boxDer}>
            {showConf && <HomeConf2 styles={this.props.styles}/>}

            {showServicio && <ConfServ2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addServicio} list={lista} handleClickidLista={this.idLista}/>}
            {addServicio && <AddServicio2 styles={this.props.styles}
               handleLista={this.handleSubclaseSer} handleLista1={this.handleListaTipoTec}
              handleLista7={this.handleparaProcMasDX} handleSubmit={this.handleServicio}
              handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verServicio && <VerSer2 styles={this.props.styles} handleSubmit={this.handleServicio} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showClase && <ConfClase2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addClase} list={lista} handleClickidLista={this.idLista}/>}
            {addClase && <AddClase2 styles={this.props.styles} handleSubmit={this.handleClase} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verClase && <VerCla2 styles={this.props.styles} handleSubmit={this.handleClase} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showSubclase && <ConfSubclase2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addSubclase} list={lista} handleClickidLista={this.idLista}/>}
            {addSubclase && <AddSubclase2 styles={this.props.styles} handleLista={this.handleClaseSub}
                    handleSubmit={this.handleSubclase} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verSubclase && <VerScl2 styles={this.props.styles} handleSubmit={this.handleSubclase} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showTiTe && <ConfTiTe2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addTiTe} list={lista} handleClickidLista={this.idLista}/>}
            {addTiTe && <AddTiTe2 styles={this.props.styles} handleSubmit={this.handleTipoTec} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verTiTe && <VerTiTe2 styles={this.props.styles} handleSubmit={this.handleTipoTec} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showImpto && <ConfImpto2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addImpto} list={lista} handleClickidLista={this.idLista}/>}
            {addImpto && <AddImpto2 styles={this.props.styles} handleSubmit={this.handleImpto} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verImpto && <VerImpto2 styles={this.props.styles} handleSubmit={this.handleImpto} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showTarifa && <ConfTar2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addTarifa} list={lista} handleClickidLista={this.idLista}/>}
            {addTarifa && <AddTar2 styles={this.props.styles} handleSubmit={this.handleTarifa}
              handleChange={this.handleChange} args={argsAdd} errors={errorAdd}
              list8={this.props.list8} comoAsigCicloFact={this.props.comoAsigCicloFact}
              handleLista={this.handleCicloFactCl}/>}
            {verTarifa && <VerTar2 a25100505={a25100505} styles={this.props.styles} handleSubmit={this.handleTarifa}
              args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate}
              permiteDelete={permiteDelete} list8={this.props.list8} comoAsigCicloFact={this.props.comoAsigCicloFact}/>}

            {showSerTar && <ConfSerT2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} lisServTar={lisServTar} lisServ={lisServ} lisServIni={lisServIni} lisServTarIni={lisServTarIni} handleVrinic={this.showSerTar} tarifa={idLista.descrTarifa} errors={errorAdd} handleSubmit={this.handleTarifaServ}/>}
            {showSerTarI && <ConfSerTI2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} list={lista} lisServTar={lisServTarI} lisServTarIni={lisServTarIniI} handleVrinic={this.showSerTarI} tarifa={idLista.descrTarifa} errors={errorAdd} handleSubmit={this.handleTarifaServI}/>}

            {showOferta && <ConfOfer2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addOferta} list={lista} handleClickidLista={this.idLista}/>}
            {addOferta && <AddOfer2 styles={this.props.styles} handleSubmit={this.handleOferta} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verOferta && <VerOfer2 styles={this.props.styles} handleSubmit={this.handleOferta} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showSerOfer && <ConfSerO2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} lisServTar={lisServTar} lisServ={lisServ} lisServIni={lisServIni} lisServTarIni={lisServTarIni} handleVrinic={this.showSerOfer} oferta={idLista.descrOferta} errors={errorAdd} handleSubmit={this.handleOfertaServ}/>}

            {showTiporec && <ConfTire2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addTiporec} list={lista} handleClickidLista={this.idLista}/>}
            {addTiporec && <AddTire2 styles={this.props.styles} handleLista={this.handleAreaaprovechTR} handleSubmit={this.handleTiporec} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verTiporec && <VerTire2 styles={this.props.styles} handleSubmit={this.handleTiporec} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showRecurso && <ConfRec2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addRecurso} list={lista} handleClickidLista={this.idLista}/>}
            {addRecurso && <AddRec2 styles={this.props.styles} list={lista} list1={lista1} list2={lista2}
              handleLista2={this.handleTipoRecRec} handleLista3={this.handleTipoDocRec} handleSubmit={this.handleRecurso}
              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
              handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad}
              modeloFactura={this.props.getParametro.getParametro.modeloFactura}
              handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verRecurso && <VerRec2 styles={this.props.styles} list={lista} list1={lista1} list2={lista2}
              handleSubmit={this.handleRecurso}
              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
              handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad}
              modeloFactura={this.props.getParametro.getParametro.modeloFactura}
              args={argsAdd} errors={errorAdd} idLista={idLista}
              permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}
            {showParametro && <VerParam2 styles={this.props.styles} list={lista} handleSubmit={this.handleParametro} args={argsAdd} errors={errorAdd} permiteUpdate={permiteUpdate}/>}

            {showBD && <ConfBD2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addBD} list={lista} handleClickidLista={this.idLista}/>}
            {addBD && <AddBD2 styles={this.props.styles} handleSubmit={this.handleBD} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verBD && <VerBD2 styles={this.props.styles} handleSubmit={this.handleBD} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showEquipo && <ConfEqu2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addEquipo} list={lista} handleClickidLista={this.idLista}/>}
            {addEquipo && <AddEqu2 styles={this.props.styles} list={lista} list1={lista1} list2={lista2} list3={lista3} handleLista={this.handleClaseEquEqu} handleLista1={this.handleMarcaEquEqu} handleLista2={this.handleFabriEquEqu} handleLista3={this.handleBodegaEqu} handleSubmit={this.handleEquipo} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verEquipo && <VerEqu2 styles={this.props.styles} list={lista} list1={lista1} list2={lista2} list3={lista3} handleSubmit={this.handleEquipo} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showClaseEqu && <ConfClaseEqu2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addClaseEqu} list={lista} handleClickidLista={this.idLista}/>}
            {addClaseEqu && <AddClaseEqu2 styles={this.props.styles} handleSubmit={this.handleClaseEqu} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verClaseEqu && <VerClaseEqu2 styles={this.props.styles} handleSubmit={this.handleClaseEqu} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showMarcaEqu && <ConfMarcaEqu2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addMarcaEqu} list={lista} handleClickidLista={this.idLista}/>}
            {addMarcaEqu && <AddMarcaEqu2 styles={this.props.styles} handleSubmit={this.handleMarcaEqu} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verMarcaEqu && <VerMarcaEqu2 styles={this.props.styles} handleSubmit={this.handleMarcaEqu} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showFabriEqu && <ConfFabriEqu2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addFabriEqu} list={lista} handleClickidLista={this.idLista}/>}
            {addFabriEqu && <AddFabriEqu2 styles={this.props.styles} handleSubmit={this.handleFabriEqu} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verFabriEqu && <VerFabriEqu2 styles={this.props.styles} handleSubmit={this.handleFabriEqu} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showBodega && <ConfBodega2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addBodega} list={lista} handleClickidLista={this.idLista}/>}
            {addBodega && <AddBodega2 styles={this.props.styles} handleSubmit={this.handleBodega} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verBodega && <VerBodega2 styles={this.props.styles} handleSubmit={this.handleBodega} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showTipoos && <ConfTios2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                  handleClick={this.addTipoos} list={lista} handleClickidLista={this.idLista}/>}
            {addTipoos && <AddTios2 styles={this.props.styles} list={lista}
                  handleLista={this.handlePermDirOS}
                  handleListaTipo={this.handleListaTipo} handleListaEOS={this.handlePermEOS}
                  handleLista1={this.handlePermTarSerOS} handleLista2={this.handlePermOfeOS}
                  handleLista3={this.handlePermEquOS} handleLista4={this.handleParaClNuOS}
                  handleListaPA={this.handlePedirPtosAdic} handleListaPI={this.handlePermImprimir}
                  handleLista5={this.handleEstCrearOS}
                  handleListaOSDA={this.handleListaOSDA} handleListaTOS={this.handleListaTOS}
                  handleLista6={this.handleEstCerrarOS}
                  handleSubmit={this.handleTipoos} handleChange={this.handleChange} args={argsAdd}
                  errors={errorAdd} />}
            {verTipoos && <VerTios2 styles={this.props.styles}  list={lista}
                  handleSubmit={this.handleTipoos} args={argsAdd} errors={errorAdd}
                  idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showClasifTipoos && <ConfClOST2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addClasifTipoos} list={lista} handleClickidLista={this.idLista}/>}
            {addClasifTipoos && <AddClOST2 styles={this.props.styles} handleSubmit={this.handleClasifOST} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verClasifTipoos && <VerClOST2 styles={this.props.styles} handleSubmit={this.handleClasifOST} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showCategTipoos && <ConfCaOST2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addCategTipoos} list={lista} handleClickidLista={this.idLista}/>}
            {addCategTipoos && <AddCaOST2 styles={this.props.styles} list={lista} handleLista={this.handleTipoOSCateg}
                  handleSubmit={this.handleCategOST} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verCategTipoos && <VerCaOST2 styles={this.props.styles}list={lista} handleLista={this.handleTipoOSCateg}
                  handleSubmit={this.handleCategOST} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allServicios, {name:'allServicios', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createServicio, {name:'createServicio'}),
  graphql(queries.mutation.editServicio, {name:'editServicio'}),
  graphql(queries.mutation.deleteServicio, {name:'deleteServicio'}),

  graphql(queries.query.allClasesServ, {name:'allClasesServ'}),
  graphql(queries.mutation.createClaseServ, {name:'createClaseServ'}),
  graphql(queries.mutation.editClaseServ, {name:'editClaseServ'}),
  graphql(queries.mutation.deleteClaseServ, {name:'deleteClaseServ'}),

  graphql(queries.query.allSubclasesServ, {name:'allSubclasesServ', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createSubclaseServ, {name:'createSubclaseServ'}),
  graphql(queries.mutation.editSubclaseServ, {name:'editSubclaseServ'}),
  graphql(queries.mutation.deleteSubclaseServ, {name:'deleteSubclaseServ'}),

  graphql(queries.query.allTipoTec, {name:'allTipoTec'}),
  graphql(queries.mutation.createTipoTec, {name:'createTipoTec'}),
  graphql(queries.mutation.editTipoTec, {name:'editTipoTec'}),
  graphql(queries.mutation.deleteTipoTec, {name:'deleteTipoTec'}),

  graphql(queries.query.allTipoRec, {name:'allTipoRec'}),
  graphql(queries.mutation.createTipoRec, {name:'createTipoRec'}),
  graphql(queries.mutation.editTipoRec, {name:'editTipoRec'}),
  graphql(queries.mutation.deleteTipoRec, {name:'deleteTipoRec'}),

  graphql(queries.query.allRecurso, {name:'allRecurso', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allTiposDoc, {name:'allTiposDoc'}),
  graphql(queries.mutation.createRecurso, {name:'createRecurso'}),
  graphql(queries.mutation.editRecurso, {name:'editRecurso'}),
  graphql(queries.mutation.deleteRecurso, {name:'deleteRecurso'}),

  graphql(queries.query.allDirmayor, {name:'allDirmayor', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.updDocumMany, {name:'updDocumMany'}),

  graphql(queries.query.allEquipo, {name:'allEquipo', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createEquipo, {name:'createEquipo'}),
  graphql(queries.mutation.editEquipo, {name:'editEquipo'}),
  graphql(queries.mutation.deleteEquipo, {name:'deleteEquipo'}),

  graphql(queries.query.allClaseEqu, {name:'allClaseEqu', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createClaseEqu, {name:'createClaseEqu'}),
  graphql(queries.mutation.editClaseEqu, {name:'editClaseEqu'}),
  graphql(queries.mutation.deleteClaseEqu, {name:'deleteClaseEqu'}),

  graphql(queries.query.allMarcaEqu, {name:'allMarcaEqu', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createMarcaEqu, {name:'createMarcaEqu'}),
  graphql(queries.mutation.editMarcaEqu, {name:'editMarcaEqu'}),
  graphql(queries.mutation.deleteMarcaEqu, {name:'deleteMarcaEqu'}),

  graphql(queries.query.allFabriEqu, {name:'allFabriEqu', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createFabriEqu, {name:'createFabriEqu'}),
  graphql(queries.mutation.editFabriEqu, {name:'editFabriEqu'}),
  graphql(queries.mutation.deleteFabriEqu, {name:'deleteFabriEqu'}),

  graphql(queries.query.allBodega, {name:'allBodega', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createBodega, {name:'createBodega'}),
  graphql(queries.mutation.editBodega, {name:'editBodega'}),
  graphql(queries.mutation.deleteBodega, {name:'deleteBodega'}),

  graphql(queries.query.allTiposOS, {name:'allTiposOS'}),
  graphql(queries.mutation.createTipoOS, {name:'createTipoOS'}),
  graphql(queries.mutation.editTipoOS, {name:'editTipoOS'}),
  graphql(queries.mutation.deleteTipoOS, {name:'deleteTipoOS'}),

  graphql(queries.query.allClasifOST, {name:'allClasifOST'}),
  graphql(queries.mutation.createClasifOST, {name:'createClasifOST'}),
  graphql(queries.mutation.editClasifOST, {name:'editClasifOST'}),
  graphql(queries.mutation.deleteClasifOST, {name:'deleteClasifOST'}),

  graphql(queries.query.allCategOST, {name:'allCategOST'}),
  graphql(queries.mutation.createCategOST, {name:'createCategOST'}),
  graphql(queries.mutation.editCategOST, {name:'editCategOST'}),
  graphql(queries.mutation.deleteCategOST, {name:'deleteCategOST'}),

  graphql(queries.query.allImpto, {name:'allImpto'}),
  graphql(queries.mutation.createImpto, {name:'createImpto'}),
  graphql(queries.mutation.editImpto, {name:'editImpto'}),
  graphql(queries.mutation.deleteImpto, {name:'deleteImpto'}),

  graphql(queries.query.allTarifa, {name:'allTarifa', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createTarifa, {name:'createTarifa'}),
  graphql(queries.mutation.editTarifa, {name:'editTarifa'}),
  graphql(queries.mutation.editTarifaUpdServ, {name:'editTarifaUpdServ'}),
  graphql(queries.mutation.deleteTarifa, {name:'deleteTarifa'}),

  graphql(queries.query.allOferta, {name:'allOferta', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createOferta, {name:'createOferta'}),
  graphql(queries.mutation.editOferta, {name:'editOferta'}),
  graphql(queries.mutation.editOfertaUpdServ, {name:'editOfertaUpdServ'}),
  graphql(queries.mutation.deleteOferta, {name:'deleteOferta'}),

  graphql(queries.query.allDirmayorRtes, {name:'allDirmayorRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {descrDpto: "123XYZ"}}]`}}}}),

  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createParametro, {name:'createParametro'}),
  graphql(queries.mutation.editParametro, {name:'editParametro'}),

  graphql(queries.query.allBaseDat, {name:'allBaseDat'}),
  graphql(queries.mutation.createBaseDat, {name:'createBaseDat'}),
  graphql(queries.mutation.editBaseDat, {name:'editBaseDat'}),
  graphql(queries.mutation.deleteBaseDat, {name:'deleteBaseDat'}),

  graphql(queries.query.allSequence, {name:'allSequence', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createSequence, {name:'createSequence'}),
  graphql(queries.mutation.editSequence, {name:'editSequence'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(HomeConf)
